{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "create": "Create",
    "update": "Update",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "gotIt": "Got It",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "search": "Search",
    "filter": "Filter",
    "name": "Name",
    "description": "Description",
    "date": "Date",
    "amount": "Amount",
    "status": "Status",
    "type": "Type",
    "email": "Email",
    "phone": "Phone",
    "language": "Language",
    "unknown": "Unknown",
    "back": "Back",
    "continue": "Continue",
    "backToDashboard": "Back to Dashboard",
    "backToSettings": "Back to Settings",
    "copy": "Copy",
    "copied": "Copied!"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "customers": "Contacts",
    "deals": "Deals",
    "tasks": "Tasks",
    "conversations": "Messages",
    "scenarios": "Scenarios",
    "settings": "Settings",
    "leads": "Leads",
    "calendar": "Calendar",
    "calculator": "Calculator",
    "calls": "Calls",
    "users": "Users",
    "reports": "Reports",
    "liveChat": "Live Chat"
  },
  "impersonation": {
    "warning": "⚠️ You are impersonating a user. All actions will be logged.",
    "switchBack": "Switch Back to Admin"
  },
  "sidebar": {
    "editSidebar": "Edit Sidebar",
    "customizeNavigation": "Customize Navigation",
    "availablePages": "Available Pages",
    "currentPages": "Current Pages",
    "dragToReorder": "Drag to reorder",
    "clickToRemove": "Click to remove",
    "clickToAdd": "Click to add",
    "resetToDefault": "Reset to Default",
    "saveChanges": "Save Changes",
    "discardChanges": "Discard Changes",
    "sidebarCustomized": "Sidebar customized successfully",
    "sidebarReset": "Sidebar reset to default"
  },
  "calendar": {
    "title": "Calendar",
    "subtitle": "Manage your tasks, deals, and appointments",
    "event": "event",
    "events": "events",
    "views": {
      "month": "Month",
      "week": "Week", 
      "day": "Day",
      "list": "List",
      "year": "Year"
    },
    "navigation": {
      "previous": "Previous",
      "today": "Today",
      "next": "Next",
      "loadingEvents": "Loading events..."
    },
    "actions": {
      "createEvent": "Create Event"
    },
    "eventModal": {
      "title": "Event Details",
      "close": "Close",
      "fields": {
        "title": "Title",
        "type": "Type",
        "startDate": "Start Date",
        "endDate": "End Date",
        "startTime": "Start Time",
        "endTime": "End Time",
        "allDay": "All day",
        "priority": "Priority",
        "description": "Description",
        "customerName": "Customer Name",
        "customerEmail": "Customer Email",
        "customerPhone": "Customer Phone",
        "meetingType": "Meeting Type",
        "customerNotes": "Customer Notes"
      },
      "types": {
        "custom": "Custom",
        "task": "Task",
        "deal": "Deal",
        "lead": "Lead",
        "appointment": "Appointment"
      },
      "priorities": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "urgent": "Urgent"
      },
      "actions": {
        "cancel": "Cancel",
        "delete": "Delete",
        "markComplete": "Mark Complete",
        "editEvent": "Edit Event"
      },
      "confirmations": {
        "cancelAppointment": "Cancel appointment \"{{title}}\"?",
        "deleteEvent": "Delete event \"{{title}}\"?",
        "markComplete": "Mark appointment \"{{title}}\" as completed?"
      },
      "messages": {
        "appointmentCompleted": "Appointment marked as completed!",
        "appointmentUpdateFailed": "Failed to update appointment",
        "appointmentUpdateError": "Error updating appointment"
      }
    },
    "createModal": {
      "title": "Create New Event",
      "fields": {
        "eventTitle": "Event Title",
        "eventTitlePlaceholder": "Enter event title",
        "eventType": "Event Type",
        "startDate": "Start Date",
        "endDate": "End Date",
        "startTime": "Start Time",
        "endTime": "End Time",
        "allDayEvent": "All day event",
        "priority": "Priority",
        "description": "Description",
        "descriptionPlaceholder": "Enter event description (optional)"
      },
      "types": {
        "custom": "Custom",
        "task": "Task",
        "deal": "Deal",
        "lead": "Lead",
        "appointment": "Appointment"
      },
      "priorities": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "urgent": "Urgent"
      },
      "actions": {
        "cancel": "Cancel",
        "createEvent": "Create Event"
      }
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "days": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    },
    "checkingAvailability": "Checking availability..."
  },
  "user": {
    "administrator": "Administrator",
    "mortgageBroker": "Mortgage Broker",
    "user": "User",
    "signOut": "Sign Out",
    "collapseMenu": "Collapse Menu",
    "expandMenu": "Expand Menu"
  },
  "table": {
    "lead": "LEAD",
    "contactInfo": "CONTACT INFO",
    "status": "STATUS",
    "urgency": "URGENCY",
    "priority": "PRIORITY",
    "tasks": "TASKS",
    "created": "CREATED",
    "assignedTo": "ASSIGNED TO",
    "actions": "ACTIONS",
    "unassigned": "Unassigned",
    "by": "by"
  },
  "auth": {
    "login": "Login",
    "register": "Register",
    "logout": "Logout",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "loginButton": "Sign In",
    "registerButton": "Create Account",
    "welcomeBack": "Welcome back",
    "createAccount": "Create your account",
    "alreadyHaveAccount": "Already have an account?",
    "dontHaveAccount": "Don't have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "selectLanguage": "Select your preferred language",
    "english": "English",
    "french": "Français",
    "recentlyLoggedIn": "Recently logged in",
    "clickToContinue": "Click on your account to continue",
    "passkeyEnabled": "Passkey enabled",
    "sms2faEnabled": "SMS 2FA enabled",
    "authAppEnabled": "Auth App enabled",
    "loginDifferentAccount": "Log into a different account",
    "signInWithPasskey": "Sign in with Passkey",
    "choosePasskeys": "Choose from your saved passkeys",
    "backToRecentAccounts": "Back to recent accounts",
    "authenticating": "Authenticating...",
    "backToHome": "Back to home",
    "enterPasswordToContinue": "Enter your password to continue",
    "sessionExpiredPleaseLogin": "Your session has expired. Please log in again."
  },
  "welcome": {
    "step1": {
      "title": "Welcome to MortgageFlow!",
      "description": "We're excited to have you here. Let's get you started with everything you need to manage your mortgage business effectively."
    },
    "step2": {
      "title": "Start Your Free Trial",
      "description": "Get full access to our Premium plan for 30 days - completely free! No credit card required. Explore all features and see how MortgageFlow can transform your business."
    },
    "actions": {
      "next": "Next",
      "back": "Back",
      "startTrial": "Start Free Trial",
      "starting": "Starting..."
    },
    "features": {
      "fullAccess": {
        "title": "Full Access",
        "description": "All premium features unlocked"
      },
      "noPayment": {
        "title": "No Payment",
        "description": "No credit card required"
      },
      "thirtyDays": {
        "title": "30 Days",
        "description": "Cancel anytime, no strings"
      }
    }
  },
  "onboarding": {
    "stepProgress": "Step {{current}} of {{total}}",
    "welcome": {
      "title": "Welcome to MortgageFlow!",
      "personalizedTitle": "Welcome, {{name}}!",
      "description": "We're thrilled to have you join us. Let's take a few moments to set up your account and get you started on the right foot.",
      "feature1Title": "Streamline Your Workflow",
      "feature1Description": "Manage deals, clients, and tasks all in one place",
      "feature2Title": "Grow Your Business",
      "feature2Description": "Track performance and make data-driven decisions"
    },
    "profile": {
      "title": "Set Up Your Public Profile",
      "description": "Configure the professional information that will be displayed publicly to clients and partners. Click any field to edit it directly.",
      "professionalTitle": "Mortgage Broker",
      "traineeTitle": "Mortgage Broker (Trainee)",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "brokerageFirm": "Brokerage Firm",
      "brokerageFirmPlaceholder": "e.g., ABC Mortgage Solutions Inc.",
      "isTrainee": "I am a trainee/intern",
      "traineeLabel": "Trainee",
      "pictureOptional": "Click to upload photo",
      "pictureTooLarge": "Image is too large. Please choose a file under 5MB.",
      "clickToEdit": "Click to edit",
      "cropPhoto": "Crop & Adjust Photo",
      "saveFailed": "Failed to save your public profile. Please try again."
    },
    "security": {
      "title": "Secure Your Account",
      "description": "Choose a security method to protect your account. We recommend using a passkey for the best experience.",
      "pleaseSelectMethod": "Please select a security method to continue",
      "deviceName": "Device Name",
      "deviceNamePlaceholder": "e.g., My iPhone, Work Laptop",
      "defaultPasskeyName": "My Device",
      "passkeyInstructions": "Click Continue and follow your device's prompts to set up biometric authentication.",
      "enterToken": "Please enter the 6-digit code from your authenticator app",
      "invalidPhoneFormat": "Invalid phone number format. Use international format (e.g., +14165551234)",
      "enterSmsCode": "Please enter the 6-digit code sent to your phone"
    },
    "trial": {
      "title": "Start Your Free Trial",
      "description": "You're all set! Start your 30-day free trial and explore everything MortgageFlow has to offer.",
      "freeTrialTitle": "30-Day Free Trial",
      "freeTrialDescription": "Full access to all premium features - no credit card required!",
      "startFailed": "Failed to start trial. Please try again."
    },
    "actions": {
      "back": "Back",
      "continue": "Continue",
      "cancel": "Cancel",
      "apply": "Apply",
      "startTrial": "Start My Free Trial"
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome back",
    "adminTitle": "Admin Dashboard",
    "adminDescription": "Overview of system-wide metrics and performance",
    "vsLastYear": "vs last year",
    "periods": {
      "today": "Today",
      "thisWeek": "This Week", 
      "thisMonth": "This Month",
      "thisYear": "This Year"
    },
    "dateFormats": {
      "weekdays": {
        "short": {
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat",
          "sun": "Sun"
        }
      },
      "months": {
        "short": {
          "jan": "Jan",
          "feb": "Feb",
          "mar": "Mar",
          "apr": "Apr",
          "may": "May",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Aug",
          "sep": "Sep",
          "oct": "Oct",
          "nov": "Nov",
          "dec": "Dec"
        }
      }
    },
    "stats": {
      "totalCustomers": "Total Customers",
      "activeDealsPipeline": "Active Deals Pipeline",
      "tasksToday": "Tasks Today",
      "avgDealSize": "Avg Deal Size"
    },
    "todaysTasks": "Today's Tasks",
    "upcomingTasks": "Upcoming Tasks",
    "recentActivity": "Recent Activity",
    "noTasks": "No tasks for today",
    "noUpcomingTasks": "No upcoming tasks",
    "widgets": {
      "leadOverview": "Lead Overview",
      "pipelineValue": "Pipeline Value",
      "pipelineStatistics": "Pipeline Statistics",
      "taskOverview": "Task Overview",
      "funded": "Funded",
      "paid": "Paid",
      "submitted": "Submitted",
      "openRevenue": "Open Revenue",
      "inPipeline": "In Pipeline",
      "newLeads": "New Leads",
      "followUpsDue": "Follow-ups Due",
      "hotLeads": "Hot Leads",
      "conversionRate": "Conversion Rate",
      "byStatus": "By Status",
      "recentActivity": "Recent Activity",
      "today": "Today",
      "thisWeek": "This Week",
      "overdue": "Overdue",
      "totalActive": "Total Active",
      "needsAttention": "Needs attention",
      "allCaughtUp": "All caught up!",
      "totalFinancingAmount": "Total Financing Amount",
      "activeDeals": "active deals",
      "activeFiles": "Active Files",
      "averageLoan": "Average Loan",
      "bankDistribution": "Bank Distribution",
      "moreBanks": "more banks",
      "expectedCommission": "Expected Commission",
      "yearlyStatistics": "Yearly Statistics",
      "totalPaidCommission": "Total Paid Commission",
      "totalLoanVolume": "Total Loan Volume",
      "leadConversionRate": "Lead Conversion Rate",
      "leads": "leads",
      "activitySummary": "Activity Summary",
      "leadsCreated": "Leads Created",
      "dealsCreated": "Deals Created",
      "dealsCompleted": "deals completed",
      "deals": "Deals",
      "financed": "Financed",
      "monthToDate": "Month to Date",
      "yearToDate": "Year to Date",
      "averageBps": "Average BPS",
      "bps": "bps",
      "averageCommissionRate": "Average Commission Rate",
      "lenderMetrics": "Lender Metrics",
      "totalLenders": "Total Lenders",
      "majorityLender": "Primary Lender",
      "lastYear": "Last 12 months",
      "ofDeals": "of deals",
      "retry": "Retry",
      "customizeDashboard": "Customize Dashboard",
      "privacyMode": "Privacy Mode",
      "showData": "Show Data",
      "addWidgets": "Add Widgets",
      "alreadyAdded": "Already Added",
      "addPipeline": "Pipeline",
      "addFunded": "Funded",
      "addSubmitted": "Submitted",
      "addOpenRevenue": "Open Revenue",
      "addPaid": "Paid",
      "addPipelineValue": "Pipeline Value",
      "addTaskOverview": "Task Overview",
      "addWhatsNew": "What's New",
      "addLeadOverview": "Lead Overview",
      "addYearlyStatistics": "Yearly Statistics",
      "addAverageBps": "Average BPS",
      "addFeedback": "Feedback",
      "addLenderMetrics": "Lender Metrics",
      "addWorldClock": "World Clock",
      "worldClock": "World Clock",
      "selectTimezones": "Select Timezones",
      "selectUpToFour": "Select up to 4 time zones",
      "businessHours": "Business Hours",
      "afterHours": "After Hours",
      "nightTime": "Night Time",
      "statusWaiting": "Waiting",
      "statusNew": "New",
      "statusCalled": "Called",
      "whatsNew": "What's New",
      "latestUpdates": "Latest updates",
      "by": "by",
      "feedback": "Feedback",
      "feedbackPlaceholder": "Share your feedback, suggestions, or feature requests...",
      "characters": "characters",
      "sendFeedback": "Send Feedback",
      "submitting": "Sending...",
      "feedbackSuccess": "Thank you! Your feedback has been submitted.",
      "feedbackError": "Failed to submit feedback. Please try again.",
      "feedbackRequired": "Please enter your feedback before submitting.",
      "feedbackAuthError": "You must be logged in to submit feedback.",
      "feedbackHelper": "Your feedback helps us improve MortgageFlow Pro!"
    },
    "announcements": {
      "types": {
        "feature": "Feature",
        "improvement": "Improvement",
        "bug_fix": "Bug Fix",
        "maintenance": "Maintenance"
      },
      "newAnnouncement": "New Announcement",
      "continueReading": "Continue reading",
      "viewAllAnnouncements": "View All Announcements",
      "pageTitle": "What's New",
      "pageSubtitle": "Stay updated with the latest features, improvements, and announcements",
      "noAnnouncementsTitle": "No Announcements Yet",
      "noAnnouncementsMessage": "Check back later for updates and new features!",
      "footerMessage": "Have feedback or suggestions? We'd love to hear from you!"
    },
    "search": {
      "placeholder": "Search customers, deals, leads, comments... (⌘K)",
      "searchCustomersDealsLeadsComments": "Search customers, deals, leads, comments... (⌘K)",
      "searching": "Searching...",
      "commentIn": "Comment in {{title}}",
      "viewAllResults": "View all {{count}} results for \"{{query}}\"",
      "noResults": "No results found for \"{{query}}\"",
      "tryDifferent": "Try different keywords or check spelling",
      "recentSearches": "Recent Searches",
      "startTyping": "Start typing to search..."
    },
    "greeting": {
      "morning": "Good morning, {firstName}! Ready to conquer the mortgage market?|Hey {firstName}! A new day of success awaits!|Morning, {firstName}! Let's make today legendary!|Hey {firstName}, morning's here—let's start by closing those deals!|Good morning, {firstName}! Ready to turn prospects into clients?|Hey {firstName}! A new day of brokering awaits!|Morning, {firstName}! Time to shine in the mortgage world!|Hey {firstName}, morning's perfect for victories!|Good morning, {firstName}! Ready to make extraordinary deals?|Hey {firstName}! A day of mortgage success begins!",
      "day": "Hey {firstName}! Afternoon's perfect for victories!|Hey {firstName}, midday energy—let's close those deals!|{firstName}, afternoon's here—time to shine!|Hey {firstName}! Day's energy—let's convert those prospects!|Hey {firstName}, afternoon's perfect for success!|{firstName}, midday energy—let's close those loans!|Hey {firstName}! Afternoon's here—time for victories!|Hey {firstName}, day's energy—let's shine in brokering!|{firstName}, afternoon's perfect for deals!|Hey {firstName}! Midday energy—let's convert those clients!",
      "evening": "Good evening, {firstName}! Time to close out the day with a win!|Hey {firstName}, evening's here—let's finish those deals strong!|{firstName}, great work today! Let's tie up those loose ends!|Evening, {firstName}! One last push to make today legendary!|Hey {firstName}, the day's winding down—let's close with flair!|{firstName}, evening's calling—seal those final deals!|Good evening, {firstName}! Let's wrap up the day with success!|Hey {firstName}, you crushed it today—let's finish strong!|{firstName}, evening's here—time to lock in those last loans!|Evening, {firstName}! Let's make tonight's deals the best yet!"
    }
  },
  "customers": {
    "title": "Contacts",
    "subtitle": "Manage your customers and partners",
    "customersTab": "Customers",
    "partnersTab": "Partners",
    "addCustomer": "Add Customer",
    "addCustomerSubtitle": "Create a new customer profile with contact information",
    "editCustomer": "Edit Customer",
    "editCustomerSubtitle": "Update customer information and contact details",
    "customerProfile": "Customer Profile",
    "customerProfileSubtitle": "View detailed customer information, notes, tasks, and mortgage applications",
    "backToList": "Back to List",
    "customerDetails": "Customer Details",
    "noCustomers": "No customers found",
    "searchPlaceholder": "Search customers...",
    "profile": "Profile",
    "deals": "Deals",
    "tasks": "Tasks",
    "conversations": "Conversations",
    "personalInfo": "Personal Information",
    "contact": "Contact",
    "notes": "Notes",
    "addNote": "Add note",
    "customerDeals": "Customer Deals",
    "customerTasks": "Customer Tasks",
    "customerConversations": "Customer Conversations",
    "customerNotFound": "Customer not found",
    "customerNotFoundDescription": "The requested customer was not found or no longer exists.",
    "backToCustomers": "Back to List",
    "createTask": "+ Create Task",
    "close": "Close",
    "form": {
      "primaryCustomerInformation": "Primary Customer Information",
      "firstName": "First Name",
      "lastName": "Last Name",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "preferredLanguage": "Preferred Language",
      "customLink": "Custom Link",
      "associatedCustomers": "Associated Customer(s)",
      "associatedCustomersDescription": "Add additional customers who will be associated with this customer. When you create a customer and add associated customers, they will be linked together and appear in each other's \"Associated Customers\" section.",
      "addCustomer": "+ Add",
      "removeCustomer": "Remove",
      "editCustomer": "Edit",
      "cancel": "Cancel",
      "createCustomer": "Create Customer",
      "createCustomers": "Create Customers",
      "updateCustomer": "Update Customer",
      "saving": "Saving...",
      "customerCreatedSuccess": "Customer created successfully!",
      "customerUpdatedSuccess": "Customer updated successfully!",
      "enterFirstName": "Enter first name",
      "enterLastName": "Enter last name",
      "enterEmail": "customer@example.com",
      "enterPhone": "(555) 123-4567",
      "enterCustomLink": "https://example.com",
      "languageFrench": "Français (French)",
      "languageEnglish": "English",
      "required": "*",
      "referredBy": "Referred by",
      "enterReferredBy": "Enter referrer's name"
    },
    "tabs": {
      "overview": "Overview",
      "properties": "Properties",
      "associatedCustomers": "Associated Customers",
      "notes": {
        "title": "Notes",
        "totalNotes": "total notes",
        "noNotesFound": "No notes found for this customer",
        "addNote": "Add note"
      },
      "tasks": {
        "title": "Tasks",
        "totalTasks": "total tasks",
        "noTasksFound": "No tasks found for this customer",
        "due": "Due",
        "created": "Created"
      },
      "deals": {
        "title": "Deals",
        "dealsCount": "deals",
        "noDealsFound": "No deals found for this customer",
        "amount": "Amount",
        "type": "Type",
        "created": "Created"
      }
    },
    "sections": {
      "primaryContact": "Primary Contact",
      "accountInformation": "Account Information",
      "recentActivity": "Recent Activity"
    },
    "labels": {
      "preferredLanguage": "Preferred Language",
      "customLink": "Custom Link",
      "associatedCustomers": "Associated Customers",
      "customerSince": "Customer Since",
      "lastUpdated": "Last Updated"
    },
    "summaryCards": {
      "totalTasks": "Total Tasks",
      "pendingTasks": "Pending Tasks",
      "notes": "Notes",
      "associatedCustomers": "Associated Customers"
    },
    "activity": {
      "task": "Task",
      "due": "Due"
    },
    "relationships": {
      "title": "Customer Relationships",
      "associations": "associations"
    },
    "table": {
      "name": "NAME",
      "email": "EMAIL",
      "phone": "PHONE",
      "actions": "ACTIONS",
      "noPhone": "No phone",
      "loadingCustomers": "Loading customers...",
      "retry": "Retry",
      "searchPlaceholder": "Search by name, email, or phone...",
      "showing": "Showing {{count}} of {{total}} customers",
      "allCustomers": "All Customers",
      "recentCustomers": "Recent Customers",
      "noCustomersFound": "No customers found",
      "noCustomersMatching": "No customers found matching \"{search}\"",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "deleting": "Deleting...",
      "viewAll": "View All {count} Customers →"
    },
    "properties": {
      "title": "Property Portfolio",
      "subtitle": "{customerName}'s properties and mortgage details",
      "addProperty": "Add Property",
      "addFirstProperty": "Add First Property",
      "tabs": {
        "allProperties": "All Properties",
        "financedByUs": "Financed by Us",
        "rentalProperties": "Rental Properties"
      },
      "emptyState": {
        "noPropertiesFound": "No properties found",
        "startBuilding": "Start building their property portfolio by adding the first property.",
        "noPropertiesForTab": "No {tab} properties found for this customer."
      }
    },
    "propertyForm": {
      "title": {
        "addNew": "Add New Property",
        "edit": "Edit Property"
      },
      "tabs": {
        "basicInfo": "Basic Info",
        "mortgageDetails": "Mortgage Details",
        "propertyDetails": "Property Details",
        "rentalInfo": "Rental Info",
        "automation": "Automation"
      },
      "sections": {
        "basicInfo": {
          "title": "Basic Property Information",
          "fields": {
            "propertyName": "Property Name",
            "propertyType": "Property Type",
            "address": "Address",
            "numberOfUnits": "Number of Units",
            "status": "Status",
            "propertyValue": "Property Value",
            "purchasePrice": "Purchase Price",
            "purchaseDate": "Purchase Date"
          },
          "placeholders": {
            "propertyName": "e.g., Main Residence, Rental Property #1",
            "address": "Full property address",
            "propertyValue": "Current estimated value",
            "purchasePrice": "Original purchase price"
          },
          "options": {
            "propertyTypes": {
              "residential": "Residential",
              "commercial": "Commercial",
              "multiFamily": "Multi-Family",
              "condo": "Condominium",
              "townhouse": "Townhouse",
              "land": "Land"
            },
            "status": {
              "active": "Active",
              "sold": "Sold",
              "underRenovation": "Under Renovation",
              "forSale": "For Sale"
            }
          }
        },
        "mortgageInfo": {
          "title": "Mortgage Information",
          "financedByUs": "Financed by Us",
          "fields": {
            "mortgageAmount": "Current Mortgage Amount",
            "originalMortgageAmount": "Original Mortgage Amount",
            "currentInterestRate": "Current Interest Rate",
            "amortizationYears": "Amortization Years",
            "termYears": "Term Years",
            "mortgageStartDate": "Mortgage Start Date",
            "renewalDate": "Renewal Date",
            "lenderName": "Lender Name",
            "mortgageType": "Mortgage Type",
            "paymentFrequency": "Payment Frequency",
            "monthlyPayment": "Monthly Payment"
          },
          "options": {
            "mortgageTypes": {
              "fixed": "Fixed",
              "variable": "Variable",
              "hybrid": "Hybrid"
            },
            "paymentFrequencies": {
              "monthly": "Monthly",
              "biWeekly": "Bi-Weekly",
              "weekly": "Weekly",
              "accelerated": "Accelerated"
            }
          }
        },
        "propertyDetails": {
          "title": "Property Details",
          "fields": {
            "bedrooms": "Bedrooms",
            "bathrooms": "Bathrooms",
            "squareFeet": "Square Feet",
            "yearBuilt": "Year Built",
            "lotSize": "Lot Size",
            "lotSizeUnit": "Lot Size Unit",
            "annualPropertyTaxes": "Annual Property Taxes",
            "annualInsurance": "Annual Insurance",
            "monthlyMaintenanceEstimate": "Monthly Maintenance Estimate",
            "notes": "Notes"
          },
          "options": {
            "lotSizeUnits": {
              "sqft": "Square Feet",
              "acres": "Acres",
              "hectares": "Hectares"
            }
          }
        },
        "rentalInfo": {
          "title": "Rental Information",
          "isRentalProperty": "Rental Property",
          "fields": {
            "monthlyRentalIncome": "Monthly Rental Income",
            "annualPropertyTaxes": "Annual Property Taxes",
            "annualInsurance": "Annual Insurance",
            "monthlyMaintenanceEstimate": "Monthly Maintenance Estimate"
          }
        },
        "automation": {
          "title": "Automation & Reminders",
          "autoRenewalReminders": "Auto Renewal Reminders",
          "renewalReminderMonths": "Months before renewal",
          "autoRateReviewReminders": "Auto Rate Review Reminders",
          "rateReviewFrequencyMonths": "Review frequency",
          "options": {
            "renewalReminderMonths": {
              "6": "Every 6 months",
              "12": "Every 12 months",
              "24": "Every 24 months"
            }
          }
        }
      },
      "buttons": {
        "cancel": "Cancel",
        "createProperty": "Create Property",
        "updateProperty": "Update Property",
        "saving": "Saving..."
      },
      "error": "Error"
    }
  },
  "deals": {
    "title": "Deals",
    "subtitle": "Manage your mortgage deals pipeline",
    "addDeal": "Add Deal",
    "createNewDeal": "Create New Deal",
    "addDealDescription": "Add a new mortgage deal to your pipeline",
    "createDeal": "Create Deal",
    "editDeal": "Edit Deal",
    "dealDetails": "Deal Details",
    "dealName": "Deal Name",
    "dealCustomers": "Deal Customers",
    "noCustomersYet": "No customers added yet. Search and add customers below.",
    "searchCustomersPlaceholder": "Search and add customers by name, email, or phone...",
    "descriptionPlaceholder": "Add any additional notes about this deal (optional)...",
    "noCustomersFound": "No customers found",
    "createNewCustomer": "Create New Customer",
    "applicant": "Applicant",
    "coApplicant": "Co-Applicant",
    "associatedCustomersPrompt": {
      "title": "Add Associated Customers?",
      "description": "{{customerName}} has {{count}} associated customer(s). Would you like to add them to this deal as co-applicants?",
      "skip": "Skip",
      "addAll": "Add All as Co-Applicants"
    },
    "loanAmount": "Loan Amount",
    "commissionPoints": "Commission Points",
    "initialStatus": "Initial Status",
    "selectStatus": "Select Status",
    "descriptionNotes": "Description & Notes",
    "archivedDeals": "Archived Deals",
    "noArchivedDeals": "No archived deals found.",
    "noDeals": "No deals found",
    "dealType": "Deal Type",
    "selectDealType": "Select Deal Type",
    "customer": "Customer",
    "selectCustomer": "Select Customer",
    "expectedCloseDate": "Expected Close Date",
    "commission": "Commission",
    "basePoints": "Base Points",
    "bonusPoints": "Bonus Points",
    "volumePoints": "Volume Points",
    "closingDate": "Closing Date",
    "pipeline": "Pipeline",
    "totalValue": "Total Value",
    "totalCommission": "Total Commission",
    "tableView": "Table View",
    "hideEmptyStatuses": "Hide empty statuses",
    "showEmptyStatuses": "Show empty statuses",
    "hide": "Hide",
    "show": "Show",
    "emptyStatuses": "empty statuses",
    "noDealsInStatus": "No deals in this status",
    "dealCount": "deal",
    "dealCountPlural": "deals",
    "actions": "Actions",
    "type": "Type",
    "netCommission": "Net Commission",
    "expectedClose": "Expected Close",
    "status": "Status",
    "created": "Created",
    "manage": "Manage",
    "dealManagement": "Deal Management",
    "dealStatus": "Deal Status",
    "dealTypesManagement": "Deal Types",
    "viewOptions": "View Options",
    "table": "Table",
    "cards": "Cards",
    "compact": "Compact",
    "archive": "Archive",
    "viewArchived": "View Archived",
    "columnSettingsDetails": {
      "title": "Column Settings",
      "columnSettings": "Column Settings",
      "subtitle": "Manage table columns for deals board view",
      "databaseIssue": "Database Issue: Database migration required - custom_columns table not found",
      "databaseError": "Database Error:",
      "databaseUnavailable": "The database service is currently unavailable. System columns are still functional.",
      "customColumnsUnavailable": "Custom columns are not available until the database migration is run.",
      "runDatabaseMigration": "Run Database Migration",
      "resetToDefaults": "Reset to Defaults",
      "addCustomColumn": "Add Custom Column",
      "saveChanges": "Save Changes",
      "availableColumns": "Available Columns",
      "totalColumns": "Total Columns",
      "visibleColumns": "Visible Columns",
      "customColumns": "Custom Columns",
      "system": "System",
      "sortable": "Sortable",
      "align": "Align",
      "left": "Left",
      "center": "Center",
      "right": "Right",
      "columnNames": {
        "dealName": "Deal Name",
        "customer": "Customer",
        "amount": "Amount",
        "type": "Type",
        "netCommission": "Net Commission",
        "expectedClose": "Expected Close",
        "status": "Status",
        "created": "Created"
      },
      "columnTypes": {
        "text": "Text",
        "number": "Number",
        "date": "Date",
        "dropdown": "Dropdown",
        "boolean": "Boolean (Yes/No)"
      },
      "customColumnEditor": {
        "addTitle": "Add Custom Column",
        "editTitle": "Edit Column",
        "addSubtitle": "Create a new custom column for your deals",
        "editSubtitle": "Modify column properties",
        "columnName": "Column Name",
        "columnNameRequired": "Column Name *",
        "columnNamePlaceholder": "e.g., Priority Level",
        "columnKey": "Column Key",
        "columnKeyRequired": "Column Key *",
        "columnKeyPlaceholder": "e.g., priority_level",
        "columnKeyHelp": "Unique identifier for this column (lowercase, underscores only)",
        "columnType": "Column Type",
        "columnTypeRequired": "Column Type *",
        "dropdownOptions": "Dropdown Options",
        "dropdownOptionsRequired": "Dropdown Options *",
        "dropdownOptionsPlaceholder": "Enter each option on a new line:\nHigh Priority\nMedium Priority\nLow Priority",
        "dropdownOptionsHelp": "Enter each option on a new line. You can edit these options later.",
        "defaultValue": "Default Value",
        "defaultValuePlaceholder": "Optional default value",
        "noDefault": "-- No default --",
        "yes": "Yes",
        "no": "No",
        "textAlignment": "Text Alignment",
        "visible": "Visible",
        "required": "Required",
        "sortable": "Sortable",
        "resizable": "Resizable",
        "cancel": "Cancel",
        "createColumn": "Create Column",
        "saveChanges": "Save Changes",
        "validation": {
          "nameRequired": "Column name is required",
          "keyRequired": "Column key is required",
          "keyFormat": "Key must start with a letter and contain only lowercase letters, numbers, and underscores",
          "keyExists": "This key already exists",
          "dropdownMinOptions": "Dropdown must have at least 2 options",
          "dropdownUniqueOptions": "Dropdown options must be unique"
        }
      }
    },
    "dealTypes": {
      "purchase": "Purchase",
      "refinance": "Refinance",
      "transfer": "Transfer",
      "other": "Other"
    },
    "dealDetail": {
      "loading": "Loading deal...",
      "errorLoading": "Error Loading Deal",
      "dealNotFound": "Deal Not Found",
      "dealNotFoundMessage": "The requested deal could not be found.",
      "backToDeals": "Back to Deals",
      "assignedTo": "Assigned to:",
      "referredBy": "Referred by",
      "manage": "Manage",
      "assignTeam": "Assign Team",
      "tools": "Tools",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving...",
      "historyComments": "Comments",
      "sms": "SMS",
      "compliance": "Compliance",
      "complianceComingSoon": "Compliance Coming Soon",
      "complianceDescription": "This section will allow you to manage compliance documents and requirements for this deal. Stay tuned for updates!",
      "commentType": "Comment Type",
      "voiceRecording": "Voice Recording & AI Transcription",
      "startRecording": "Start Recording",
      "addNoteOrComment": "Add Note or Comment",
      "addNotePlaceholder": "Add a detailed note or comment... Press Enter for new paragraphs.",
      "addComment": "Add Comment",
      "addingComment": "Adding Comment...",
      "pinComment": "Pin comment",
      "unpinComment": "Unpin comment",
      "pinnedComment": "Pinned",
      "toolsModal": {
        "title": "Deal Tools & Calculators",
        "subtitle": "Quick access to helpful tools and calculators for this deal",
        "noToolsYet": "No tools available yet",
        "noToolsDescription": "Tools and calculators will be added here soon to help you manage this deal more efficiently.",
        "comingSoon": "Coming Soon",
        "exportPdf": {
          "title": "Export Deal Summary",
          "description": "Generate a comprehensive PDF report with all deal details and comments",
          "selectLanguage": "Report Language",
          "english": "English",
          "french": "French",
          "generating": "Generating PDF...",
          "downloadPdf": "Download PDF"
        }
      },
      "associatedTasks": "Associated Tasks",
      "currentTasks": "Current Tasks",
      "recentlyCompleted": "Recently Completed",
      "noTasksAssociated": "No tasks associated with this deal yet.",
      "createTask": "Create Task",
      "taskCreationError": "Failed to create task. Please try again.",
      "due": "Due:",
      "priority": "Priority:",
      "complete": "Complete",
      "completed": "Completed",
      "commissionSummary": "Commission Summary",
      "commissionCalculation": "Commission Calculation",
      "baseBps": "Base Bps",
      "bonusBps": "Bonus Bps",
      "volumeBps": "Volume Bps",
      "totalBps": "Total Bps",
      "totalPoints": "Total Points",
      "grossCommission": "Gross Commission",
      "agencyFee": "Agency Fee",
      "closingFee": "Closing Fee",
      "netCommission": "Net Commission",
      "commissionSplits": "Commission Splits",
      "addCommissionSplit": "Add Commission Split",
      "editCommissionSplit": "Edit Commission Split",
      "deleteCommissionSplit": "Delete Commission Split",
      "confirmDeleteSplit": "Are you sure you want to delete this commission split?",
      "partner": "Partner",
      "selectPartner": "Select Partner",
      "searchPartner": "Search partner...",
      "createPartner": "Create \"{{name}}\"",
      "noPartnerFound": "No partner found",
      "splitType": "Split Type",
      "percentage": "Percentage",
      "fixedAmount": "Fixed Amount",
      "splitValue": "Split Value",
      "splitNotes": "Notes",
      "splitNotesPlaceholder": "Optional notes about this commission split...",
      "calculatedAmount": "Calculated Amount",
      "noCommissionSplits": "No commission splits yet",
      "addFirstSplit": "Add your first commission split to share commission with partners",
      "totalSplitAmount": "Total Split Amount",
      "brokerCommission": "Your Commission",
      "splitCreatedSuccess": "Commission split created successfully",
      "splitUpdatedSuccess": "Commission split updated successfully",
      "splitDeletedSuccess": "Commission split deleted successfully",
      "splitCreationError": "Failed to create commission split",
      "splitUpdateError": "Failed to update commission split",
      "splitDeleteError": "Failed to delete commission split",
      "dealSummary": "Deal Summary",
      "dealId": "Deal ID",
      "dealName": "Deal Name",
      "dealType": "Deal Type",
      "dealVersion": "Deal Version",
      "lender": "Lender",
      "searchLender": "Search lender...",
      "selectLender": "Select a lender",
      "createLender": "Create \"{{name}}\"",
      "noLenderFound": "No lender found",
      "lenderRequired": "Lender name is required",
      "created": "Created",
      "lastUpdated": "Last Updated",
      "expectedClose": "Expected Close",
      "actualClose": "Actual Close",
      "notSpecified": "Not specified",
      "notSet": "Not set",
      "commentTypes": {
        "comment": "General Comment",
        "internal_note": "Internal Note",
        "call": "Call",
        "text": "Text/SMS",
        "email": "Email",
        "in_person": "In-Person",
        "other": "Other"
      },
      "statusChanges": {
        "assignedAsCollaborator": "assigned as collaborator",
        "removedFromCollaborator": "removed from collaborator assignment",
        "statusChangedFrom": "Status changed from",
        "to": "to"
      },
      "assignments": {
        "manageDealAssignments": "Manage Deal Assignments",
        "currentAssignments": "Current Assignments",
        "addTeamMember": "Add Team Member",
        "remove": "Remove",
        "collaborator": "Collaborator",
        "primaryAssignee": "Primary Assignee",
        "noTeamMembersAvailable": "No team members available. Invite collaborators from Settings to assign them to deals.",
        "allTeamMembersAssigned": "All available team members are already assigned to this deal.",
        "addAsCollaborator": "Add as Collaborator",
        "addAsPrimary": "Add as Primary"
      },
      "archivedDealChangeStatus": "Archived Deal - Change Status:",
      "selectStatus": "Select Status",
      "archivedLabel": "(Archived)",
      "selectNonArchivedToReopen": "Select a non-archived status to reopen"
    },
    "defaultStatuses": {
      "assemblingDocumentation": "Assembling documentation",
      "submission": "Submission", 
      "conditionsFullfilment": "Conditions Fullfilment",
      "approved": "Approved",
      "funded": "Funded",
      "archive": "Archive"
    }
  },
  "tasks": {
    "title": "Tasks",
    "subtitle": "Manage your mortgage brokering tasks with focus on today and the week ahead",
    "boardTitle": "Tasks Board",
    "tomorrow": "Tomorrow",
    "loadingBoard": "Loading tasks board...",
    "addTask": "Add Task",
    "createTask": "Create Task",
    "editTask": "Edit Task",
    "taskDetails": "Task Details",
    "noTasks": "No tasks found",
    "createFirstTask": "Create your first task to get started",
    "dueDate": "Due Date",
    "priority": "Priority",
    "completed": "Completed",
    "pending": "Pending",
    "overdue": "Overdue",
    "archive": "Archive",
    "viewArchived": "View Archived",
    "later": "Later",
    "expand": "Expand",
    "collapse": "Collapse",
    "moreTasks": "more tasks",
    "board": "Board",
    "table": "Table",
    "task": "Task",
    "associatedWith": "Associated With",
    "status": "Status",
    "actions": "Actions",
    "dueToday": "Due Today",
    "upcoming": "Upcoming",
    "scheduled": "Scheduled",
    "noDate": "No Date",
    "moreTasks": "more tasks",
    "task": "task",
    "tasks": "tasks",
    "manage": "Manage",
    "viewOptions": "View Options",
    "boardView": "Board View",
    "tableView": "Table View",
    "calendarView": "Calendar View",
    "filterByPriority": "Filter by Priority",
    "filterByDate": "Filter by Date",
    "filterByType": "Filter by Type",
    "allPriorities": "All Priorities",
    "allDates": "All Dates",
    "allTypes": "All Types",
    "thisWeek": "This Week",
    "customers": "Customers",
    "leads": "Leads",
    "deals": "Deals",
    "generalTasks": "General Tasks",
    "resetFilters": "Reset Filters",
    "priorities": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "urgent": "Urgent"
    },
    "todaysTasks": "Today's Tasks",
    "upcomingTasks": "Upcoming Tasks",
    "modals": {
      "taskCompleted": "Task Completed! 🎉",
      "scheduleFollowUp": "Schedule Follow-up Task (Optional)",
      "followUpPlaceholder": "What's the next step?",
      "priorityLevel": "Priority Level",
      "whenShouldBeDone": "When should this be done?",
      "orPickDate": "Or pick date:",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "skipFollowUp": "Skip follow-up to just complete",
      "justComplete": "Just Complete",
      "completeAndFollowUp": "Complete + Follow-up",
      "pushBack": "Push Back",
      "createFollowing": "Create Following",
      "close": "Close",
      "associatedWith": "Associated with",
      "created": "Created",
      "customer": "Customer",
      "willBeLinkedToDeal": "Will be linked to the same deal",
      "generalTask": "General Task (not associated with any customer, lead, or deal)",
      "loadingLeadDetails": "Loading lead details...",
      "description": "Description",
      "dueDate": "Due Date",
      "priority": "Priority",
      "quickTask": "Quick Task",
      "whatNeedsToBeDone": "What needs to be done?",
      "searchCustomerOrLead": "Search customer or lead...",
      "customers": "Customers",
      "leads": "Leads",
      "linkToDeal": "Link to a deal (optional):",
      "whenIsThisDue": "When is this due?",
      "whenDue": "When is this due?",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next Week",
      "orPickDate": "Or pick a date:",
      "setSpecificTime": "Set specific time (will block calendar slot)",
      "time": "Time:",
      "fifteenMinuteSlot": "15-minute slot will be blocked for appointments",
      "cmdEnterToCreate": "⌘ + Enter to create quickly",
      "cmdEnterHint": "⌘ + Enter to create quickly",
      "cancel": "Cancel",
      "createTask": "Create Task"
    },
    "completedTasks": "Completed Tasks"
  },
  "leads": {
    "title": "Leads",
    "subtitle": "Manage your leads and convert them to customers",
    "addLead": "Add Lead",
    "addFirstLead": "Add Your First Lead",
    "noLeadsFound": "No leads found",
    "getStarted": "Get started by adding your first lead to begin tracking potential customers.",
    "allStatuses": "All Statuses",
    "urgency": "Urgency",
    "allUrgencyLevels": "All Urgency Levels",
    "searchPlaceholder": "Search leads...",
    "task": "task",
    "tasks": "tasks",
    "bestContact": "Best contact",
    "created": "Created",
    "convert": "Convert",
    "editLead": "Edit Lead",
    "addNewLead": "Add New Lead",
    "viewTable": "View Table",
    "viewCards": "View Cards",
    "status": "Status",
    "days": "days",
    "day": "day",
    "unassigned": "Unassigned",
    "clickToViewDetails": "Click to view details",
    "contactInformation": "Contact Information",
    "leadDetails": "Lead Details",
    "description": "Description",
    "timeline": "Timeline",
    "email": "Email",
    "phone": "Phone",
    "by": "by",
    "close": "Close",
    "followUp": "Follow-up",
    "edit": "Edit",
    "delete": "Delete",
    "firstName": "First Name",
    "lastName": "Last Name",
    "addTaskOptional": "Add Task (Optional)",
    "taskDescription": "Task Description",
    "dueDate": "Due Date",
    "priority": "Priority",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "convertLead": "Convert Lead",
    "convertingLead": "Converting lead",
    "completeRequiredInfo": "Complete Required Information",
    "customizeDeal": "Customize Deal (Optional)",
    "taskManagement": "Task Management",
    "dealName": "Deal Name",
    "amount": "Amount",
    "expectedCloseDate": "Expected Close Date",
    "dealType": "Deal Type",
    "dealStatus": "Deal Status",
    "selectDealType": "Select deal type",
    "selectDealStatus": "Select deal status",
    "convertTasks": "Convert associated tasks to customer tasks",
    "cancel": "Cancel",
    "update": "Update",
    "createLead": "Create Lead",
    "followUpWithLead": "Follow up with lead...",
    "pleaseProvideContact": "Please provide at least one contact field (name, email, or phone)",
    "failedToSaveLead": "Failed to save lead",
    "areYouSureDelete": "Are you sure you want to delete this lead?",
    "failedToDeleteLead": "Failed to delete lead",
    "leadConvertedSuccessfully": "Lead converted successfully!",
    "failedToConvertLead": "Failed to convert lead",
    "pleaseFillMissingFields": "Please fill in the missing required fields:",
    "dealCreatedAutomatically": "A deal will be created automatically. You can customize the details below or leave them blank to use defaults.",
    "bestContactTime": "Best Contact Time",
    "assignedTo": "Assigned To",
    "assignedOn": "Assigned on",
    "statusNew": "New",
    "statusCalled": "Called",
    "statusEmailed": "Emailed",
    "statusWaiting": "Waiting",
    "statusQualified": "Qualified",
    "statusNotInterested": "Not Interested",
    "urgencyLow": "Low",
    "urgencyMedium": "Medium",
    "urgencyHigh": "High",
    "updateLeadInfo": "Update lead information and tracking details",
    "captureNewLeadInfo": "Capture new lead information to start tracking",
    "firstNamePlaceholder": "Enter first name",
    "lastNamePlaceholder": "Enter last name",
    "emailPlaceholder": "email@example.com",
    "phonePlaceholder": "(555) 123-4567",
    "descriptionPlaceholder": "Add notes about this lead...",
    "createFollowUpTask": "Optionally create a follow-up task for this lead",
    "source": "Source",
    "searchPartner": "Search for a partner...",
    "noPartnersFound": "No partners found",
    "createNewPartner": "Create New Partner",
    "addPartnerDetails": "Add partner contact details",
    "agency": "Agency",
    "partnerNameRequired": "Partner name is required",
    "failedToCreatePartner": "Failed to create partner",
    "createPartner": "Create Partner"
  },
  "conversations": {
    "title": "Messages",
    "addConversation": "Add Conversation",
    "startRecording": "Start Recording",
    "stopRecording": "Stop Recording",
    "transcription": "Transcription",
    "summary": "Summary",
    "noConversations": "No conversations found",
    "speakNow": "Speak now...",
    "transcribing": "Transcribing...",
    "generating": "Generating summary...",
    "conversationType": "Conversation Type",
    "general": "General",
    "mortgageConsultation": "Mortgage Consultation",
    "saveTranscription": "Save Transcription"
  },
  "partners": {
    "title": "Partners",
    "subtitle": "Manage your referral partners and collaborators",
    "addPartner": "Add Partner",
    "editPartner": "Edit Partner",
    "backToList": "Back to List",
    "partnerDetails": "Partner Details",
    "noPartners": "No partners found",
    "searchPlaceholder": "Search partners...",
    "form": {
      "partnerInformation": "Partner Information",
      "firstName": "First Name",
      "lastName": "Last Name",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "agency": "Agency",
      "commissionCut": "Commission Cut (%)",
      "cancel": "Cancel",
      "createPartner": "Create Partner",
      "updatePartner": "Update Partner",
      "saving": "Saving...",
      "partnerCreatedSuccess": "Partner created successfully!",
      "partnerUpdatedSuccess": "Partner updated successfully!",
      "enterFirstName": "Enter first name",
      "enterLastName": "Enter last name",
      "enterEmail": "partner@example.com",
      "enterPhone": "(555) 123-4567",
      "enterAgency": "Agency name",
      "enterCommissionCut": "e.g., 25",
      "required": "*",
      "optional": "(Optional)",
      "commissionCutHint": "Percentage of commission split"
    },
    "table": {
      "name": "NAME",
      "email": "EMAIL",
      "phone": "PHONE",
      "agency": "AGENCY",
      "cut": "CUT",
      "actions": "ACTIONS",
      "noPhone": "No phone",
      "noEmail": "No email",
      "noAgency": "No agency",
      "noCut": "Not set",
      "loadingPartners": "Loading partners...",
      "retry": "Retry",
      "searchPlaceholder": "Search by name, email, agency, or phone...",
      "showing": "Showing {{count}} of {{total}} partners",
      "allPartners": "All Partners",
      "recentPartners": "Recent Partners",
      "noPartnersFound": "No partners found",
      "noPartnersMatching": "No partners found matching \"{search}\"",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "deleting": "Deleting..."
    }
  },
  "scenarios": {
    "title": "Scenario Builder",
    "createScenario": "Create Scenario",
    "scenarioName": "Scenario Name",
    "propertyValue": "Property Value",
    "downPayment": "Down Payment",
    "amortization": "Amortization",
    "paymentFrequency": "Payment Frequency",
    "generateReport": "Generate Report",
    "exportPDF": "Export PDF",
    "noScenarios": "No scenarios found"
  },
  "settings": {
    "title": "Settings",
    "adminTitle": "Admin Settings",
    "brokerDescription": "Customize your mortgage brokering experience",
    "adminDescription": "Manage system-wide configurations and user permissions",
    "comingSoon": "Coming Soon",
    "welcomeTitle": "Welcome to Settings",
    "welcomeMessage": "Select a setting from the sidebar to get started",
    "sections": {
      "account": "Account",
      "system": "System",
      "users": "Users & Access",
      "billing": "Billing & Payments",
      "communication": "Communication",
      "analytics": "Analytics",
      "deals": "Deals",
      "tasks": "Tasks & Workflows",
      "organization": "Organization",
      "leads": "Leads & Forms",
      "schedule": "Schedule"
    },
    "adminNotice": "Administrator Notice",
    "adminNoticeText": "As an administrator, you have access to system-wide settings and user management features. Some advanced configuration options are still in development and will be available in future updates.",
    "needHelp": "Need Help?",
    "helpText": "If you need assistance with any settings or have questions about configuring your system, our support team is here to help.",
    "contactSupport": "Contact Support (Coming Soon)",
    "viewDocs": "View Documentation (Coming Soon)",
    "profile": "User Profile",
    "profileDesc": "Update your personal information and preferences",
    "dealStatuses": "Deal Statuses",
    "dealStatusesDesc": "Manage your deal pipeline statuses and workflow",
    "dealTypes": "Deal Types",
    "dealTypesDesc": "Configure mortgage deal types and categories",
    "financialSettings": "Financial Settings",
    "financialSettingsDesc": "Set up commission rates, fees, and financial tracking",
    "taskDelays": "Task Delays",
    "reminderOffsets": "Reminder Offsets",
    "twilioSettings": "Twilio Settings",
    "smsTemplates": "SMS Templates",
    "agencyFeePercentage": "Agency Fee Percentage",
    "closingFeeAmount": "Closing Fee Amount",
    "addStatus": "Add Status",
    "editStatus": "Edit Status",
    "addType": "Add Type",
    "editType": "Edit Type",
    "statusName": "Status Name",
    "statusNameFr": "Status Name (French)",
    "typeName": "Type Name",
    "typeNameFr": "Type Name (French)",
    "color": "Color",
    "position": "Position",
    "darkMode": "Dark Mode",
    "lightMode": "Light Mode",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "admin": {
      "systemConfig": {
        "title": "System Configuration",
        "description": "Manage global system settings and configurations"
      },
      "userManagement": {
        "title": "User Management",
        "description": "Advanced user permissions and role management"
      },
      "stripeConfig": {
        "title": "Stripe Configuration",
        "description": "Configure Stripe payment processing and API settings"
      },
      "membershipManagement": {
        "title": "Membership Management",
        "description": "Create and manage membership tiers and permissions"
      },
      "platformSettings": {
        "title": "Platform Settings",
        "description": "Configure platform-wide features and integrations"
      },
      "customerMigration": {
        "title": "Customer Name Migration",
        "description": "Migrate customer names from single field to first/last name format"
      },
      "announcements": {
        "title": "Announcements",
        "description": "Manage \"What's New\" announcements and platform updates"
      },
      "telnyxIntegration": {
        "title": "Telnyx Integration (Admin)",
        "description": "Configure Telnyx API, default SMS number, and welcome messages"
      },
      "analytics": {
        "title": "Analytics & Reporting",
        "description": "Configure system-wide analytics and reporting"
      },
      "smsAdminSettings": {
        "title": "SMS Settings",
        "description": "Configure SMS messaging, welcome messages, lead notifications, and SMS actions"
      },
      "impersonate": "Impersonate User"
    },
    "taskManagement": {
      "title": "Task Management",
      "description": "Configure task delays and reminder settings"
    },
    "smsSettings": {
      "title": "SMS Settings",
      "description": "Configure SMS preferences and two-way messaging"
    },
    "phoneNumberManagement": {
      "title": "Phone Number Management",
      "description": "Purchase and manage your dedicated phone number for calls and SMS",
      "adminDescription": "Manage phone number inventory and user assignments"
    },
    "membershipManagement": {
      "title": "Membership Management",
      "description": "Manage your subscription and billing information"
    },
    "leadsManagement": {
      "title": "Leads Management",
      "description": "Configure lead statuses, urgency levels, and custom form settings"
    },
    "usersManagement": {
      "title": "Users Management",
      "description": "Invite collaborators and manage team permissions"
    },
    "workflowManagement": {
      "title": "Workflow Management",
      "description": "Create and manage automated workflows for your deals by type and version",
      "templates": "Templates",
      "createWorkflow": "Create Workflow",
      "workflowTemplates": "Workflow Templates",
      "templatesCreated": "{{count}} template created",
      "templatesCreated_plural": "{{count}} templates created",
      "noWorkflowsYet": "No Workflows Yet",
      "noWorkflowsDescription": "Create your first workflow template to get started.",
      "steps": "{{count}} step",
      "steps_plural": "{{count}} steps",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "toggleStatus": "Toggle Status",
      "delete": "Delete",
      "selectWorkflowTemplate": "Select a Workflow Template",
      "selectDescription": "Choose a workflow template from the left to view and edit its steps.",
      "createNewWorkflow": "Create New Workflow",
      "addStep": "Add Step",
      "noWorkflowSteps": "No Workflow Steps",
      "noWorkflowStepsDescription": "Add your first workflow step to define the process flow.",
      "addFirstStep": "Add First Step",
      "start": "Start",
      "end": "End",
      "automations": "{{count}} automation",
      "automations_plural": "{{count}} automations",
      "dealVersions": {
        "commercial": "Commercial",
        "residential": "Residential"
      },
      "createModal": {
        "title": "Create Workflow Template",
        "workflowName": "Workflow Name",
        "workflowNamePlaceholder": "e.g., Purchase Residential Workflow",
        "dealType": "Deal Type",
        "selectDealType": "Select a deal type",
        "dealVersion": "Deal Version",
        "description": "Description",
        "descriptionPlaceholder": "Optional description of this workflow...",
        "cancel": "Cancel",
        "createButton": "Create Workflow"
      },
      "messages": {
        "loadError": "Failed to load workflow data",
        "createSuccess": "Workflow template created successfully",
        "createError": "Failed to create workflow template",
        "updateSuccess": "Workflow template updated successfully",
        "updateError": "Failed to update workflow template",
        "deleteSuccess": "Workflow template deleted successfully",
        "deleteError": "Failed to delete workflow template",
        "duplicateSuccess": "Workflow template duplicated successfully",
        "stepCreateSuccess": "Workflow step created successfully",
        "stepUpdateSuccess": "Workflow step updated successfully",
        "stepDeleteSuccess": "Workflow step deleted successfully",
        "deleteConfirm": "Are you sure you want to delete this workflow template? This action cannot be undone.",
        "templateCreated": "Workflow template created successfully!",
        "configSaved": "Configuration saved successfully!",
        "validationSaveError": "Failed to save validation requirements",
        "automationSaveError": "Failed to save automation rules",
        "saveError": "Failed to save configuration"
      },
      "validation": {
        "title": "Validation",
        "description": "Required Fields for Status Transition",
        "helpText": "Select which deal fields must be filled before a deal can transition to this status. These validations will be enforced when changing deal status.",
        "selectedFields": "{{count}} fields required",
        "noFieldsRequired": "No fields required"
      },
      "automationRules": {
        "title": "Automation Rules",
        "addRule": "Add New Rule"
      }
    },
    "statusRules": {
      "title": "Deal Status Rules",
      "description": "Add validation and automation rules to your deal statuses",
      "dealStatuses": "Deal Statuses",
      "noStatuses": "No statuses found",
      "selectStatus": "Select a deal status to view and manage its rules",
      "rulesFor": "Rules for",
      "rules": "rules",
      "addRule": "Add Rule",
      "noRules": "No rules configured for this status",
      "noRulesDesc": "Add validation rules and automations to customize your workflow",
      "ruleCreated": "Rule created successfully",
      "createFailed": "Failed to create rule",
      "createError": "Error creating rule",
      "ruleUpdated": "Rule updated successfully",
      "updateFailed": "Failed to update rule",
      "updateError": "Error updating rule",
      "ruleDeleted": "Rule deleted successfully",
      "deleteFailed": "Failed to delete rule",
      "deleteError": "Error deleting rule",
      "confirmDelete": "Are you sure you want to delete this rule?",
      "ruleToggled": "Rule toggled successfully",
      "toggleError": "Error toggling rule",
      "createRule": "Create Rule",
      "editRule": "Edit Rule",
      "ruleName": "Rule Name",
      "trigger": "Trigger",
      "requiredFields": "Required Fields",
      "customValidation": "Custom Validation",
      "validationMessage": "Validation Message",
      "automation": "Automation",
      "priority": "Priority",
      "active": "Active"
    },
    "customFormSettings": {
      "title": "Custom Form Settings",
      "description": "Configure appointment booking, meeting types, and custom lead forms"
    },
    "liveChat": {
      "title": "Support Ticket Management",
      "description": "Respond to broker support requests and manage tickets"
    },
    "liveChatSettings": {
      "title": "Support System Settings",
      "description": "Configure business hours, notifications, and auto-responses"
    },
    "brokerSupport": {
      "title": "Get Support",
      "description": "Request help from platform administrators"
    },
    "scheduleSettings": {
      "title": "Schedule Settings",
      "description": "Configure your availability hours, vacation time, and booking preferences for client appointments",
      "weeklyAvailability": "Weekly Availability",
      "weeklyAvailabilityTip": "Set your regular business hours for each day of the week. Clients will only be able to book appointments during these times.",
      "vacationTitle": "Vacation & Special Closed Days",
      "vacationTip": "Block out vacation time, holidays, or special closed days. These dates will be unavailable for client bookings.",
      "bookingPreferences": "Booking Preferences",
      "bookingPreferencesTip": "Configure how far in advance clients can book and buffer time between appointments.",
      "days": {
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday"
      },
      "closed": "Closed",
      "addHours": "+ Add Hours",
      "copyFrom": "Copy from...",
      "to": "to",
      "removeTimeSlot": "Remove time slot",
      "addVacationPeriod": "Add Vacation Period",
      "recurring": "Recurring",
      "recurringAnnually": "Recurring annually",
      "yearly": "yearly",
      "monthly": "monthly",
      "removeVacationPeriod": "Remove vacation period",
      "name": "Name",
      "namePlaceholder": "e.g., Christmas Vacation, Summer Break",
      "startDate": "Start Date",
      "endDate": "End Date",
      "cancel": "Cancel",
      "timezone": "Timezone",
      "bufferTime": "Buffer Time (minutes)",
      "bufferTimeHelp": "Time between appointments",
      "maxAdvanceBooking": "Max Advance Booking (days)",
      "maxAdvanceBookingHelp": "How far ahead clients can book",
      "minAdvanceBooking": "Min Advance Booking (hours)",
      "minAdvanceBookingHelp": "Minimum notice required",
      "saveScheduleSettings": "Save Schedule Settings",
      "saving": "Saving...",
      "savedSuccess": "Schedule settings saved successfully!",
      "savedError": "Failed to save schedule settings. Please try again.",
      "copiedSchedule": "Copied schedule from {{from}} to {{to}}"
    }
  },
  "leadSettings": {
    "title": "Leads Settings",
    "subtitle": "Configure lead statuses and urgency levels for your lead management system.",
    "leadStatuses": "Lead Statuses",
    "urgencyLevels": "Urgency Levels",
    "addStatus": "Add Status",
    "addUrgencyLevel": "Add Urgency Level",
    "editStatus": "Edit Status",
    "editUrgencyLevel": "Edit Urgency Level",
    "addNewStatus": "Add New Status",
    "addNewUrgencyLevel": "Add New Urgency Level",
    "noStatusesConfigured": "No statuses configured. Add your first status to get started.",
    "noUrgencyLevelsConfigured": "No urgency levels configured. Add your first urgency level to get started.",
    "name": "Name",
    "color": "Color",
    "statusName": "Status name",
    "urgencyLevelName": "Urgency level name",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "create": "Create",
    "update": "Update",
    "saving": "Saving...",
    "confirmDeleteStatus": "Are you sure you want to delete this status?",
    "confirmDeleteUrgency": "Are you sure you want to delete this urgency level?",
    "statusCreatedSuccess": "Status created successfully",
    "statusUpdatedSuccess": "Status updated successfully",
    "statusDeletedSuccess": "Status deleted successfully",
    "urgencyCreatedSuccess": "Urgency level created successfully",
    "urgencyUpdatedSuccess": "Urgency level updated successfully",
    "urgencyDeletedSuccess": "Urgency level deleted successfully",
    "failedToLoadSettings": "Failed to load settings",
    "failedToSaveStatus": "Failed to save status",
    "failedToDeleteStatus": "Failed to delete status",
    "failedToSaveUrgency": "Failed to save urgency level",
    "failedToDeleteUrgency": "Failed to delete urgency level"
  },
  "voice": {
    "makeCall": "Make Call",
    "incomingCall": "Incoming Call",
    "answer": "Answer",
    "decline": "Decline",
    "endCall": "End Call",
    "mute": "Mute",
    "unmute": "Unmute",
    "calling": "Calling...",
    "connected": "Connected",
    "callEnded": "Call Ended"
  },
  "validation": {
    "required": "This field is required",
    "invalidEmail": "Please enter a valid email address",
    "invalidPhone": "Please enter a valid phone number",
    "passwordTooShort": "Password must be at least 6 characters",
    "passwordsDoNotMatch": "Passwords do not match",
    "invalidAmount": "Please enter a valid amount"
  },
  "messages": {
    "saved": "Successfully saved",
    "deleted": "Successfully deleted",
    "updated": "Successfully updated",
    "created": "Successfully created",
    "savingError": "Error saving data",
    "deletingError": "Error deleting data",
    "loadingError": "Error loading data",
    "networkError": "Network error. Please try again.",
    "loginSuccess": "Login successful",
    "logoutSuccess": "Logout successful",
    "registrationSuccess": "Registration successful"
  },
  "appointment": {
    "selectMeetingType": "Select Meeting Type",
    "selectDateTime": "Select Date & Time",
    "yourDetails": "Your Details",
    "appointmentBooked": "Appointment Booked!",
    "back": "Back",
    "next": "Next",
    "bookAppointment": "Book Appointment",
    "booking": "Booking...",
    "loading": "Loading...",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email Address",
    "phone": "Phone Number",
    "notes": "Additional Notes (optional)",
    "firstNamePlaceholder": "First name",
    "lastNamePlaceholder": "Last name",
    "emailPlaceholder": "Enter your email address",
    "phonePlaceholder": "Enter your phone number",
    "notesPlaceholder": "Tell us about your mortgage needs or any questions you have...",
    "duration": "Duration",
    "confirmationMessage": "You'll receive a confirmation email shortly with all the meeting details and a calendar invite.",
    "meetingDetails": "Meeting Details",
    "noAvailableTimes": "No available times for this date",
    "selectDifferentDate": "Please select a different date",
    "selectDateFirst": "Select a date to view available times",
    "selectDatePrompt": "Select a date to view available times",
    "availableTimes": "Available Times",
    "at": "at",
    "with": "With",
    "meetingType": "Meeting Type",
    "dateTime": "Date & Time",
    "fillAllFields": "Please fill in all required fields",
    "rescheduleInfo": "Need to reschedule? Contact us or check your confirmation email for options."
  },
  "customForm": {
    "howToBeContacted": "How would you like to be contacted?",
    "contactMeASAP": "Contact me ASAP",
    "contactMeASAPDesc": "I'll get back to you as soon as possible based on your preferences",
    "scheduleAppointment": "Schedule an appointment",
    "scheduleAppointmentDesc": "Pick a time that works for you from my calendar",
    "optional": "(optional)",
    "atLeastOneField": "At least one field is required",
    "submitting": "Submitting...",
    "requiredField": "Please provide at least your name, email, or phone number.",
    "selectPriority": "Please select a priority.",
    "brokerNotFound": "Broker not found",
    "brokerNotFoundMessage": "The requested broker profile could not be found.",
    "errorTitle": "Error",
    "errorMessage": "There was an error submitting your information. Please try again or contact me directly.",
    "contactDirect": "Contact me directly:",
    "poweredBy": "Powered by"
  },
  "customFormSettings": {
    "title": "Custom Form Settings",
    "subtitle": "Configure your appointment booking system and custom lead forms",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "tabs": {
      "general": "General",
      "contactForm": "Contact Form",
      "appointments": "Appointments"
    },
    "meetingTypes": {
      "title": "Meeting Types",
      "tip": "Meeting types define the duration and purpose of appointments. Customers will choose from these options when booking.",
      "addMeetingType": "Add Meeting Type",
      "noMeetingTypes": "No meeting types configured yet.",
      "addFirstMeetingType": "Add your first meeting type to enable appointment booking.",
      "duration": "Duration",
      "bufferBefore": "Buffer before",
      "bufferAfter": "Buffer after",
      "inactive": "Inactive",
      "edit": "Edit",
      "delete": "Delete",
        "modal": {
          "addTitle": "Add New Meeting Type",
          "editTitle": "Edit Meeting Type",
          "nameEn": "Name (English) *",
          "nameFr": "Name (French)",
          "nameEnPlaceholder": "e.g., Initial Consultation",
          "nameFrPlaceholder": "e.g., Consultation initiale",
          "descriptionEn": "Description (English)",
          "descriptionFr": "Description (French)",
          "descriptionEnPlaceholder": "Brief description of this meeting type",
          "descriptionFrPlaceholder": "Brief description of this meeting type",
          "durationMinutes": "Duration (minutes) *",
          "color": "Color",
          "bufferBefore": "Buffer Before (min)",
          "bufferAfter": "Buffer After (min)",
          "active": "Active (available for booking)",
          "cancel": "Cancel",
          "update": "Update",
          "create": "Create",
          "saving": "Saving..."
        }
    },
    "designPresets": {
      "title": "Design Presets",
      "tip": "Choose a design preset to quickly style your custom form. You can customize colors and text after selecting a preset.",
      "yourFormUrl": "Your custom form URL:",
      "preview": "Preview",
      "saveConfiguration": "Save Configuration",
      "saving": "Saving...",
      "custom": "Custom",
      "customizeColors": "Customize your own colors",
      "applyPreset": "Apply Preset",
      "customizeColorsTitle": "Customize Colors",
      "customizeColorsTip": "Customize your form's color scheme to match your branding. Changes apply immediately to your live form.",
      "colorLabel": "Color"
    },
    "textLabels": {
      "title": "Text & Labels",
      "tip": "Customize all text and labels shown on your custom form. Support for both English and French.",
      "formTitles": "Form Titles",
      "titleEn": "Title (English)",
      "titleFr": "Titre (Français)",
      "subtitleEn": "Subtitle (English)",
      "subtitleFr": "Sous-titre (Français)",
      "buttonSuccessMessages": "Button & Success Messages",
      "submitButtonEn": "Submit Button (English)",
      "submitButtonFr": "Bouton de soumission (Français)",
      "successTitleEn": "Success Title (English)",
      "successTitleFr": "Titre de succès (Français)",
      "successMessageEn": "Success Message (English)",
      "successMessageFr": "Message de succès (Français)",
      "fieldLabels": "Field Labels",
      "english": "English",
      "french": "Français",
      "firstNameLabel": "First Name Label",
      "lastNameLabel": "Last Name Label",
      "emailLabel": "Email Label",
      "phoneLabel": "Phone Label",
      "messageLabel": "Message Label",
      "messagePlaceholder": "Message Placeholder",
      "firstNameLabelFr": "Étiquette Prénom",
      "lastNameLabelFr": "Étiquette Nom",
      "emailLabelFr": "Étiquette Email",
      "phoneLabelFr": "Étiquette Téléphone",
      "messageLabelFr": "Étiquette Message",
      "messagePlaceholderFr": "Texte d'aide Message",
      "appointmentBookingLabels": "Appointment Booking Labels",
      "selectMeetingType": "Select Meeting Type",
      "selectDateTime": "Select Date & Time",
      "backButton": "Back Button",
      "nextButton": "Next Button",
      "selectMeetingTypeFr": "Sélectionner type de rendez-vous",
      "selectDateTimeFr": "Sélectionner date et heure",
      "backButtonFr": "Bouton Précédent",
      "nextButtonFr": "Bouton Suivant"
    },
    "brokerInfo": {
      "title": "Broker Info",
      "tip": "Configure your professional title and contact information for the custom form.",
      "contactInfoNotice": {
        "title": "Contact Information Now Managed in Profile Settings",
        "description": "Your contact information (name, email, phone) displayed on custom forms is now managed in",
        "link": "Profile Settings → Public Information"
      },
      "professionalTitle": "Professional Title",
      "titleEn": "Title (English)",
      "titleFr": "Titre (Français)"
    },
    "formFields": {
      "title": "Form Fields",
      "tip": "Configure which fields to show on your custom form and set your custom URL slug.",
      "customFormUrl": "Custom Form URL",
      "customUrlSlug": "Custom URL Slug",
      "urlSlugHint": "Only letters, numbers, hyphens, and underscores allowed",
      "yourFormUrl": "Your custom form URL:",
      "copy": "Copy",
      "fieldVisibility": "Field Visibility",
      "firstNameField": "First Name Field",
      "firstNameFieldDesc": "Show the first name input field",
      "emailField": "Email Field",
      "emailFieldDesc": "Show the email input field (recommended)",
      "messageField": "Message Field",
      "messageFieldDesc": "Show the message textarea field"
    },
    "notifications": {
      "title": "SMS & Notifications",
      "tip": "Configure SMS templates for lead submissions, appointment confirmations, and reminders. Use variables to personalize messages.",
      "save": "Save Settings",
      "saving": "Saving...",
      "saveSuccess": "Notification settings saved successfully!",
      "saveError": "Failed to save notification settings",
      "availableVariables": "Available Variables",
      "var": {
        "customerName": "Customer's full name",
        "customerPhone": "Customer's phone number",
        "customerEmail": "Customer's email address",
        "message": "Customer's message",
        "brokerName": "Your name",
        "meetingType": "Type of meeting",
        "appointmentDate": "Appointment date",
        "appointmentTime": "Appointment time",
        "reminderTime": "Time until appointment"
      },
      "leadSubmission": "Lead Submission SMS",
      "appointmentBroker": "Appointment Confirmation - Broker",
      "appointmentCustomer": "Appointment Confirmation - Customer",
      "reminderBroker": "Appointment Reminder - Broker",
      "reminderCustomer": "Appointment Reminder - Customer",
      "smsTemplateEn": "SMS Template (English)",
      "smsTemplateFr": "SMS Template (French)",
      "reminderSettings": "Reminder Settings",
      "enableReminders": "Enable Appointment Reminders",
      "enableRemindersDesc": "Send reminder notifications before appointments",
      "minutesBefore": "Send Reminder (minutes before appointment)",
      "minutesBeforeDesc": "Default: 120 minutes (2 hours)"
    },
    "messages": {
      "meetingTypeSaved": "Meeting type saved successfully!",
      "meetingTypeDeleted": "Meeting type deleted successfully!",
      "configSaved": "Configuration saved successfully!",
      "errorSaving": "Error saving configuration",
      "errorLoading": "Error loading settings",
      "confirmDelete": "Are you sure you want to delete this meeting type?"
    }
  },
  "teamManagement": {
    "title": "Team Management",
    "subtitle": "Advanced team collaboration and permission management system",
    "backToSettings": "Back to Settings",
    "sendInvite": "Send Invite",
    "tabs": {
      "teamInvites": "Team & Invites",
      "permissionMatrix": "Permission Matrix",
      "teamAnalytics": "Team Analytics",
      "departments": "Departments"
    },
    "activeCollaborators": {
      "title": "Active Collaborators",
      "noCollaborators": "No collaborators yet",
      "noCollaboratorsDesc": "Start building your team by inviting collaborators to help manage your mortgage business.",
      "sendFirstInvite": "Send First Invite",
      "tableHeaders": {
        "collaborator": "Collaborator",
        "contact": "Contact",
        "permissions": "Permissions",
        "status": "Status",
        "joined": "Joined"
      }
    },
    "pendingInvites": {
      "title": "Pending Invites",
      "tableHeaders": {
        "phoneNumber": "Phone Number",
        "permissions": "Permissions",
        "status": "Status",
        "expires": "Expires",
        "actions": "Actions"
      },
      "cancel": "Cancel",
      "confirmCancel": "Are you sure you want to cancel this invite?"
    },
    "permissions": {
      "viewOnly": "View Only",
      "editTasks": "Edit Tasks",
      "editDeals": "Edit Deals",
      "editCustomers": "Edit Customers",
      "manageSms": "Manage SMS"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "suspended": "Suspended",
      "pending": "Pending",
      "accepted": "Accepted",
      "expired": "Expired",
      "cancelled": "Cancelled"
    },
    "inviteModal": {
      "title": "Send Collaborator Invite",
      "phoneNumber": "Phone Number",
      "phonePlaceholder": "+1 (555) 123-4567",
      "role": "Collaborator Role",
      "roleDescription": "Choose a predefined role or customize permissions below",
      "permissionsTitle": "Permissions",
      "customizable": "(Customizable)",
      "viewOnlyDesc": "View Only - Can view all data but cannot make changes",
      "editTasksDesc": "Edit Tasks - Can create, update, and manage tasks",
      "editDealsDesc": "Edit Deals - Can create, update, and manage deals",
      "editCustomersDesc": "Edit Customers - Can create, update, and manage customers",
      "manageSmsDesc": "Manage SMS - Can send and receive SMS messages",
      "cancel": "Cancel",
      "sendInvite": "Send Invite",
      "sending": "Sending...",
      "phoneRequired": "Phone number is required",
      "error": "Failed to send invite"
    },
    "permissionMatrix": {
      "title": "Advanced Permission Matrix",
      "description": "Manage granular permissions for each team member with the Nuclear Permission System."
    },
    "analytics": {
      "title": "Team Performance Analytics",
      "description": "Real-time insights into team activity, performance metrics, and collaboration patterns."
    },
    "departments": {
      "title": "Department & Hierarchy Management",
      "description": "Organize your team into departments with clear reporting structures and role assignments."
    },
    "departmentManager": {
      "title": "Department Management",
      "description": "Organize your team into departments with dedicated leadership",
      "newDepartment": "New Department",
      "createNewDepartment": "Create New Department",
      "editDepartment": "Edit Department",
      "createDepartment": "Create Department",
      "updateDepartment": "Update Department",
      "departmentName": "Department Name",
      "departmentNameRequired": "Department Name *",
      "departmentNamePlaceholder": "e.g. Sales Team",
      "description": "Description",
      "descriptionPlaceholder": "Brief description of this department...",
      "departmentColor": "Department Color",
      "custom": "Custom",
      "departmentLead": "Department Lead",
      "noLeadAssigned": "No lead assigned",
      "teamMembers": "Team Members",
      "cancel": "Cancel",
      "saving": "Saving...",
      "deactivateConfirm": "Are you sure you want to deactivate this department? This will remove all members from the department.",
      "active": "Active",
      "inactive": "Inactive",
      "created": "Created",
      "noDepartmentsTitle": "No departments yet",
      "noDepartmentsDescription": "Get started by creating your first department to organize your team structure and workflow.",
      "createFirstDepartment": "Create Your First Department",
      "editTooltip": "Edit department",
      "deactivateTooltip": "Deactivate department",
      "failedToSave": "Failed to save department"
    },
    "accessDenied": {
      "title": "Access Denied",
      "message": "Only mortgage brokers can access user management."
    },
    "advancedTeamManagement": {
      "title": "Advanced Team Management",
      "subtitle": "Comprehensive team management with advanced permissions, analytics, and organizational tools",
      "inviteMember": "Invite Member",
      "bulkImport": "Bulk Import",
      "teamOverview": "Team Overview",
      "welcome": "Welcome to Advanced Team Management",
      "welcomeDesc": "Manage your team with enterprise-grade tools for permissions, analytics, and organization",
      "granularPermissions": "Granular Permissions",
      "granularPermissionsDesc": "Set specific permissions for each team member with our advanced permission matrix",
      "analyticsDesc": "Track team performance, activity, and engagement with detailed analytics",
      "departmentStructure": "Department Structure",
      "departmentStructureDesc": "Organize your team into departments with dedicated leadership and hierarchy",
      "teamMembers": "Team Members",
      "roleTemplates": "Role Templates",
      "recentActivity": "Recent Activity",
      "lastSevenDays": "Last 7 days",
      "gettingStarted": "Getting Started",
      "setupDepartments": "Set up departments",
      "setupDepartmentsDesc": "Organize your team into logical departments with dedicated leadership",
      "configurePermissions": "Configure permissions",
      "configurePermissionsDesc": "Use the permission matrix to set granular access controls for each team member",
      "createRoleTemplates": "Create role templates",
      "createRoleTemplatesDesc": "Build reusable permission templates for common roles in your organization",
      "monitorAnalytics": "Monitor analytics",
      "monitorAnalyticsDesc": "Track team performance and engagement through comprehensive analytics",
      "accessRestricted": "Access Restricted",
      "noPermissionMessage": "You don't have permission to access team management features. Contact your administrator for access."
    }
  },
  "userProfile": {
    "title": "User Profile",
    "description": "Manage your personal information and account security",
    "tabs": {
      "accountInformation": "Account Information",
      "publicInformation": "Public Information",
      "changePassword": "Change Password",
      "securityFeatures": "Security Features"
    },
    "accountInformation": {
      "title": "Account Information",
      "description": "Manage your private account details",
      "profilePicture": {
        "title": "Profile Picture",
        "choosePicture": "Choose Picture",
        "maxSize": "Max 5MB. JPG, PNG, GIF supported.",
        "cropPhoto": "Crop & Adjust Photo",
        "zoom": "Zoom",
        "apply": "Apply",
        "savePicture": "Save Picture",
        "removePicture": "Remove Picture",
        "cancel": "Cancel",
        "uploading": "Uploading...",
        "confirmRemove": "Are you sure you want to remove your profile picture?",
        "tooLarge": "Profile picture must be less than 5MB",
        "invalidType": "Please select an image file",
        "uploadSuccess": "Profile picture updated successfully!",
        "uploadError": "Failed to upload profile picture",
        "removeSuccess": "Profile picture removed successfully!",
        "removeError": "Failed to remove profile picture"
      },
      "fields": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "emailAddress": "Email Address",
        "phoneNumber": "Phone Number"
      },
      "saveChanges": "Save Changes",
      "saving": "Saving...",
      "updateSuccess": "Account information updated successfully!",
      "updateError": "Failed to update account information",
      "loadError": "Failed to load user profile"
    },
    "publicInformation": {
      "title": "Public Information",
      "description": "This information is visible to customers and appears on your business card",
      "fields": {
        "displayFirstName": "Display First Name",
        "displayLastName": "Display Last Name",
        "displayEmail": "Public Email Address",
        "displayPhone": "Public Phone Number",
        "brokerageFirmName": "Brokerage Firm Name",
        "isTrainee": "I am a trainee mortgage broker"
      },
      "hint": "These are the details that customers will see when you share your contact information",
      "saveChanges": "Save Changes",
      "saving": "Saving...",
      "updateSuccess": "Public information updated successfully!",
      "updateError": "Failed to update public information",
      "loadError": "Failed to load public information"
    },
    "changePassword": {
      "title": "Change Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "passwordRequirements": "Password must be at least 8 characters with uppercase, lowercase, and number",
      "changePassword": "Change Password",
      "changing": "Changing...",
      "passwordMismatch": "New password and confirmation do not match",
      "changeSuccess": "Password changed successfully!",
      "changeError": "Failed to change password"
    },
    "securityFeatures": {
      "title": "Security Features",
      "aboutTitle": "About Security Features",
      "aboutDescription": "Enhance your account security with passkeys and two-factor authentication. These features provide additional layers of protection beyond your password.",
      "quickLogin": {
        "title": "Quick Login Preference",
        "active": "Active",
        "description": "Choose your preferred security method for quick login when clicking your account on the login screen. This will be the first method prompted when you try to log in.",
        "passkey": "Passkey",
        "passkeyDescription": "Use biometric authentication (fingerprint, face recognition)",
        "authenticatorApp": "Authenticator App",
        "authenticatorDescription": "Use a 6-digit code from your authenticator app",
        "smsVerification": "SMS Verification",
        "smsDescription": "Receive a code via text message",
        "noPreferenceNote": "Don't want a quick login preference? You can always use the regular login form.",
        "preferenceCleared": "Quick login preference cleared",
        "preferenceUpdated": "Quick login preference updated successfully!",
        "preferenceError": "Failed to update quick login preference",
        "preferenceSetLocally": "Quick login preference set (will sync when backend is deployed)"
      },
      "passkeysNotSupported": {
        "title": "Passkeys Not Supported",
        "message": "Your browser or device doesn't support passkeys. Please use a modern browser like Chrome, Safari, or Firefox on a device with biometric authentication."
      }
    },
    "accountDetails": {
      "title": "Account Details",
      "accountCreated": "Account Created:",
      "lastUpdated": "Last Updated:"
    }
  },
  "security": {
    "secureYourAccount": "Secure Your Account",
    "requiredForProtection": "Required for account protection",
    "securitySetupRequired": "Security Setup Required",
    "securityPolicyMessage": "To protect your account and comply with security policies, you must set up at least one additional security feature.",
    "chooseSecurityMethod": "Choose a Security Method",
    "passkeys": "Passkeys",
    "passkey": "Passkey",
    "passkeyDescription": "Use your fingerprint, face, or device PIN to sign in securely",
    "passkeyVerifyDescription": "Use your biometric authentication",
    "passkeyRecommended": "Passkey (Recommended)",
    "passkeySetupDescription": "Quick and secure with biometric authentication",
    "smsAuthentication": "SMS Authentication",
    "smsDescription": "Receive verification codes via text message",
    "authenticatorApp": "Authenticator App",
    "authenticatorDescription": "Use Google Authenticator or similar apps",
    "settingUp": "Setting up...",
    "setupFeature": "Set up {{feature}}",
    "noSecurityFeatures": "No security features are available on this device.",
    "contactSupport": "Please contact support for assistance.",
    "setupFailed": "Failed to set up security feature. Please try again.",
    "setupError": "An error occurred during setup",
    "mandatoryNote": "This is mandatory for all accounts. You can add more security features later in your profile settings.",
    "checkingSecurity": "Checking Security...",
    "verificationRequired": "Security Verification Required",
    "chooseVerificationMethod": "Choose a method to verify your identity:",
    "enter6DigitCode": "Enter your 6-digit code",
    "usePasskeyToVerify": "Use your passkey to verify your identity",
    "verifying": "Verifying...",
    "verifyWithPasskey": "Verify with Passkey",
    "verify": "Verify",
    "enterCodeFromApp": "Enter the 6-digit code from your authenticator app:",
    "setupSecurityMessage": "To protect your account, please set up at least one security feature:",
    "skipFor7Days": "Skip for 7 days",
    "scanQRCode": "Scan this QR code with your authenticator app:",
    "orManualSecret": "Or manually enter this secret:",
    "enterCodeToVerify": "Enter the 6-digit code from your app to verify:",
    "verifyAndEnable2FA": "Verify and Enable 2FA",
    "2FAEnabledSuccess": "2FA Enabled Successfully!",
    "saveBackupCodes": "Save these backup codes in a secure place:",
    "continueToDashboard": "Continue to Dashboard",
    "sms2faVerification": "SMS Verification",
    "receiveCodeViaSMS": "Receive code via text message",
    "enterSMSCode": "Enter the 6-digit code sent to your phone",
    "sendingCode": "Sending verification code to your phone...",
    "resendCode": "Resend code",
    "resendIn": "Resend in {{seconds}}s",
    "setupSuccessful": "Security Feature Added!",
    "featureAddedMessage": "Your account is now more secure!",
    "recommendMultipleFeatures": "For maximum security, consider adding another authentication method.",
    "addAnotherFeature": "Add Another Security Feature",
    "useDifferentMethod": "Use a different security method",
    "cancelVerification": "Cancel Login"
  },
  "securityFeatureCards": {
    "active": "Active",
    "passkeysDescription": "Passkeys are a secure, passwordless way to sign in using your device's biometric authentication (fingerprint, face, or touch).",
    "addNewPasskey": "Add New Passkey",
    "passkeyPlaceholder": "e.g., iPhone, Laptop, Yubikey",
    "registering": "Registering...",
    "register": "Register",
    "noPasskeys": "No passkeys registered yet. Add one above to get started!",
    "added": "Added",
    "lastUsed": "Last used",
    "remove": "Remove",
    "twoFactorAuth": "Two-Factor Authentication (2FA)",
    "enabled": "Enabled",
    "twoFactorAuthDescription": "Add an extra layer of security by requiring a time-based one-time password from your authenticator app (like Google Authenticator, Authy, or Microsoft Authenticator).",
    "settingUp": "Setting up...",
    "enable2FA": "Enable 2FA",
    "step1ScanQR": "Step 1: Scan QR Code",
    "openAuthAppScan": "Open your authenticator app and scan this QR code:",
    "orManuallyEnterSecret": "Or manually enter this secret key:",
    "step2EnterCode": "Step 2: Enter Verification Code",
    "enter6DigitCodeFromApp": "Enter the 6-digit code from your authenticator app:",
    "verifyAndEnable": "Verify and Enable",
    "saveBackupCodesWarning": "Save these backup codes in a secure place. You can use them to access your account if you lose your authenticator device:",
    "copyCodes": "Copy Codes",
    "twoFactorActive": "Two-factor authentication is active",
    "disabling": "Disabling...",
    "disable": "Disable",
    "sms2FA": "SMS Two-Factor Authentication",
    "sms2FADescription": "Receive verification codes via SMS on your mobile phone. A secure and convenient way to protect your account.",
    "enableSMS2FA": "Enable SMS 2FA",
    "phoneNumber": "Phone Number",
    "phoneNumberPlaceholder": "e.g., +1 416 555 1234",
    "phoneNumberHelper": "Enter your phone number in international format (E.164)",
    "sendVerificationCode": "Send Verification Code",
    "verificationCodeSent": "Verification code sent to your phone",
    "enterSMSCode": "Enter the 6-digit code from your SMS:",
    "codePlaceholder": "000000",
    "resendCode": "Resend Code",
    "resendCodeIn": "Resend code in {{seconds}}s",
    "sms2FAActive": "SMS two-factor authentication is active",
    "registeredPhone": "Registered phone: {{phone}}",
    "disableSMS2FA": "Disable SMS 2FA",
    "confirmPasswordToDisable": "Enter your password to disable SMS 2FA:",
    "passwordRequired": "Password is required",
    "invalidPhoneFormat": "Invalid phone number format. Use E.164 format (e.g., +14165551234)"
  },
  "trial": {
    "badge": "Trial",
    "freeTrial": "Free Trial",
    "daysRemaining": "{days} days remaining",
    "clickToUpgrade": "Click to upgrade",
    "trialExpired": "Trial expired",
    "upgrade": "Upgrade"
  },
  "dealStatusSettings": {
    "title": "Deal Status Management",
    "subtitle": "Manage your deal pipeline statuses with drag-and-drop ordering and custom colors",
    "backToSettings": "Back to Settings",
    "addNewStatus": "Add New Status",
    "pipelineStatuses": "Pipeline Statuses",
    "tip": "Tip: Drag and drop statuses to reorder your pipeline. The order here determines how they appear in your deals board.",
    "statusName": "Status Name",
    "statusNamePlaceholder": "Enter status name",
    "color": "Color",
    "selectColor": "Select Color",
    "lead": "Lead",
    "closed": "Closed",
    "compliance": "Compliance",
    "archived": "Archived",
    "submitted": "Submitted",
    "editStatus": "Edit Status",
    "deleteStatus": "Delete Status",
    "editSmsTemplate": "Edit SMS Template",
    "setupSmsTemplate": "Set up SMS Template",
    "noStatusesConfigured": "No deal statuses configured yet",
    "createFirstStatus": "Create Your First Status",
    "saveChanges": "Save Changes",
    "cancel": "Cancel",
    "confirmDelete": "Are you sure you want to delete this status?",
    "smsTemplates": "SMS Templates",
    "englishTemplate": "English Template",
    "frenchTemplate": "French Template",
    "templatePlaceholder": "Enter your SMS template...",
    "saveTemplates": "Save Templates",
    "templatesSaved": "SMS templates saved successfully!",
    "failedToSaveTemplates": "Failed to save SMS templates",
    "configured": "Configured",
    "notConfigured": "Not configured",
    "statusProperties": "Status Properties"
  },
  "dealTypesSettings": {
    "title": "Deal Types Management",
    "subtitle": "Manage your deal types and categories",
    "backToSettings": "Back to Settings",
    "addDealType": "Add Deal Type",
    "availableDealTypes": "Available Deal Types",
    "dealTypeName": "Deal Type Name",
    "dealTypeNamePlaceholder": "Enter deal type name",
    "frenchName": "French Name",
    "frenchNamePlaceholder": "Enter French name (optional)",
    "supportsCommercial": "Supports Commercial",
    "supportsResidential": "Supports Residential",
    "active": "Active",
    "inactive": "Inactive",
    "commercial": "Commercial",
    "residential": "Residential",
    "noDealTypesConfigured": "No deal types configured yet",
    "createFirstDealType": "Create Your First Deal Type",
    "editDealType": "Edit Deal Type",
    "deleteDealType": "Delete Deal Type",
    "confirmDelete": "Are you sure you want to delete this deal type?",
    "dealTypeNameRequired": "Deal type name is required",
    "dealTypeAdded": "Deal type added successfully!",
    "dealTypeUpdated": "Deal type updated successfully!",
    "dealTypeDeleted": "Deal type deleted successfully!",
    "failedToAddDealType": "Failed to add deal type",
    "failedToUpdateDealType": "Failed to update deal type",
    "failedToDeleteDealType": "Failed to delete deal type",
    "failedToLoadDealTypes": "Failed to load deal types"
  },
  "financialSettings": {
    "title": "Financial Settings",
    "description": "Configure commission calculations and closing fees",
    "backToSettings": "Back to Settings",
    "commissionConfiguration": "Commission Configuration",
    "agencyFeePercentage": "Agency Fee Percentage (%)",
    "agencyFeePercentageHint": "Percentage of the deal amount (e.g., 1.25% of loan amount)",
    "closingFeeAmount": "Closing Fee Amount ($)",
    "closingFeeAmountHint": "Fixed amount added to each deal commission",
    "saveFinancialSettings": "Save Financial Settings",
    "saving": "Saving…",
    "commissionCalculator": "Commission Calculator",
    "dealAmount": "Deal Amount ($)",
    "commissionPoints": "Commission Points (100 = 1%)",
    "calculatedPercentage": "Calculated percentage",
    "grossCommission": "Gross Commission",
    "agencyFee": "Agency Fee",
    "closingFee": "Closing Fee",
    "netCommission": "Net Commission",
    "currentConfiguration": "Current Configuration",
    "example": "Example",
    "net": "net",
    "tip": "Tip: How It Works:",
    "tipPoints": "Points are calculated as: 100 points = 1%, so 150 points = 1.5%",
    "tipCalculation": "Gross Commission = Deal Amount × (Points ÷ 10000)",
    "tipNetCalculation": "Net Commission = Gross - (Gross × Agency Fee %) - Closing Fee",
    "tipOverride": "You can override individual deal commissions if needed",
    "enterAmountAndPoints": "Enter deal amount and commission points to see calculation",
    "agencyFeeTitle": "Agency Fee",
    "agencyFeeSubtitle": "Percentage deducted from gross commission",
    "ofGrossCommission": "of gross commission",
    "agencyFeeExample": "Example: 1.25% means the agency takes 1.25% of the gross commission on every deal.",
    "closingFeesTitle": "Closing Fees by Loan Amount",
    "closingFeesSubtitle": "Set different flat fees based on the loan amount",
    "addTier": "Add tier",
    "fromAmount": "From amount",
    "closingFeeColumn": "Closing fee",
    "baseBadge": "base",
    "removeTier": "Remove tier",
    "tierRangeUpTo": "Applies to deals from {{from}} up to {{to}}",
    "tierRangeAndAbove": "Applies to deals {{from}} and above",
    "singleTierNote": "Single tier — the same closing fee applies to all deals regardless of loan amount. Add more tiers to differentiate by loan size.",
    "howItsCalculated": "How it's calculated",
    "formulaGross": "**Gross** = Loan amount × (Points ÷ 10,000)",
    "formulaAgencyFee": "**Agency fee** = Gross × Agency fee %",
    "formulaClosingFee": "**Closing fee** = flat fee for the deal's loan amount tier",
    "formulaNet": "**Net** = Gross − Agency fee − Closing fee",
    "pointsNote": "100 points = 1%, so 150 points = 1.5%",
    "firstTierMustBeZero": "The first tier must start at $0.",
    "commissionCalculatorTitle": "Commission Calculator",
    "loanAmount": "Loan amount",
    "points": "Points",
    "tierApplied": "Tier applied: from {{from}} → {{fee}} closing fee",
    "grossLabel": "Gross ({{pct}}%)",
    "agencyFeeLabel": "Agency fee ({{pct}}%)",
    "closingFeeLabel": "Closing fee",
    "netCommissionLabel": "Net commission",
    "enterAmountBreakdown": "Enter a loan amount and points to see the breakdown",
    "messages": {
      "settingsSaved": "Financial settings saved successfully!",
      "failedToSave": "Failed to save financial settings",
      "failedToLoad": "Failed to load financial settings",
      "noAuthToken": "No authentication token"
    }
  },
  "membership": {
    "title": "Membership",
    "subtitle": "Manage your subscription, payment methods, and invoices",
    "backToSettings": "Back to Settings",
    "page": {
      "subtitle": "Manage your subscription via Stripe",
      "accessDenied": "Access Denied",
      "brokerOnly": "Membership settings are only available for broker accounts.",
      "loadError": "Failed to load membership information.",
      "currentPlan": "Current Plan",
      "plan": "Plan",
      "noActivePlan": "No active plan",
      "perMonth": "/mo",
      "status": "Status",
      "trialEnds": "Trial ends",
      "accessUntil": "Access until",
      "nextRenewal": "Next renewal",
      "billing": "Billing",
      "manageBilling": "Manage Billing",
      "opening": "Opening…",
      "refreshStatus": "Refresh status",
      "stripeNote": "Subscription management, plan changes, payment methods, and invoices are handled securely through Stripe.",
      "recentInvoices": "Recent Invoices",
      "noInvoices": "No invoices yet",
      "date": "Date",
      "amount": "Amount",
      "downloadPdf": "Download PDF",
      "portalError": "Could not open billing portal. Please contact support.",
      "portalRetry": "Could not open billing portal. Please try again.",
      "statusTrialing": "Trial — {{days}} days left",
      "statusCanceling": "Cancels at period end",
      "statusInactive": "Inactive"
    },
    "accessDenied": "Access Denied",
    "brokerOnly": "This page is only available to brokers.",
    "subscriptionRequired": "Subscription Required",
    "choosePlanBelow": "Choose a membership plan below to continue using all features.",
    "tabs": {
      "subscription": "Subscription & Usage",
      "billing": "Payment & Billing",
      "invoices": "Invoices"
    },
    "subscription": {
      "title": "Subscription Information",
      "currentPlan": "Current Plan",
      "noPlan": "No Plan",
      "status": "Status",
      "inactive": "Inactive",
      "renewsOn": "Renews on",
      "cancelsOn": "Cancels on",
      "trialEndsOn": "Free Trial Ends",
      "nextPayment": "Next Payment",
      "willBeCharged": "will be charged",
      "noUpcomingPayment": "No upcoming payment",
      "accessUntil": "Access until",
      "availablePlans": "Available Plans",
      "perMonth": "/mo",
      "currentPlanBadge": "Current Plan",
      "freeTrialDays": "{days} days free trial",
      "unlimited": "Unlimited",
      "customers": "Customers",
      "deals": "Deals",
      "tasks": "Tasks",
      "choosePlan": "Choose Plan",
      "downgrade": "Downgrade",
      "cancelSubscription": "Cancel Subscription",
      "cancelDescription": "Cancel your subscription at any time. You'll keep access until the end of your current billing period.",
      "cancelButton": "Cancel Subscription"
    },
    "payment": {
      "title": "Payment Methods",
      "description": "Manage your saved cards",
      "addCard": "Add Card",
      "noPaymentMethods": "No payment methods",
      "addCardDescription": "Add a credit or debit card to manage your subscription",
      "default": "Default",
      "expired": "Expired",
      "expires": "Expires",
      "addingCard": "Adding Card...",
      "cardDetails": "Card Details",
      "addPaymentMethod": "Add Payment Method",
      "securePayments": "🔒 Secure Payments",
      "stripeSecurityNotice": "Your payment information is securely stored and processed by Stripe, not by us. We never see or store your full card details."
    },
    "billing": {
      "title": "Billing Address",
      "description": "Your billing address for invoices",
      "editAddress": "Edit",
      "addAddress": "Add",
      "noBillingAddress": "No billing address",
      "addAddressDescription": "Add your billing address for invoices",
      "streetAddress": "Street Address",
      "aptSuite": "Apt, Suite, etc. (Optional)",
      "city": "City",
      "province": "Province",
      "postalCode": "Postal Code",
      "postalCodeHint": "Enter with or without space",
      "saveAddress": "Save Address",
      "billingAddressModal": "Billing Address",
      "selectProvince": "Select..."
    },
    "invoices": {
      "title": "Invoice History",
      "noInvoices": "No invoices yet",
      "invoicesDescription": "Your invoices will appear here once you have an active subscription",
      "date": "Date",
      "amount": "Amount",
      "status": "Status",
      "actions": "Actions",
      "download": "Download",
      "paid": "Paid",
      "pending": "Pending",
      "failed": "Failed"
    },
    "modals": {
      "cancelSubscription": "Cancel Subscription?",
      "cancelDescription": "Your subscription will remain active until the end of your current billing period. After that, you'll lose access to premium features.",
      "yesCancelButton": "Yes, Cancel",
      "keepSubscription": "Keep Subscription",
      "canceling": "Canceling..."
    },
    "messages": {
      "planChanged": "Successfully changed plan to {plan}",
      "subscriptionSuccess": "🎉 Successfully subscribed to {plan} for {price}/month! Your subscription is now active.",
      "subscriptionSuccessGracePeriod": "✅ Successfully subscribed to {plan}! Since you've already paid for this period, you won't be charged again until your next billing date.",
      "subscriptionSuccessTrial": "🎁 Successfully subscribed to {plan}! You can continue enjoying your free trial - you'll be charged when your trial ends.",
      "subscriptionCancelled": "Subscription cancelled successfully",
      "paymentMethodAdded": "Payment method added successfully",
      "paymentMethodRemoved": "Payment method removed successfully",
      "billingAddressSaved": "Billing address saved successfully",
      "failedToChangePlan": "Failed to change plan",
      "failedToCancelSubscription": "Failed to cancel subscription",
      "failedToRemovePaymentMethod": "Failed to remove payment method",
      "failedToSaveBillingAddress": "Failed to save billing address",
      "failedToFetchMembership": "Failed to fetch membership information",
      "confirmChangePlan": "Change your plan to {plan} for {price}/month?",
      "confirmRemovePaymentMethod": "Remove this payment method?",
      "addPaymentMethodFirst": "Please add a payment method first before subscribing to a paid plan."
    }
  },
  "emailSettings": {
    "title": "Email Integration",
    "subtitle": "Connect your Gmail, Outlook, or any email account to MortgageFlow",
    "connectNew": "Connect New Email Account",
    "connectDescription": "Connect your email accounts to view and manage emails directly in MortgageFlow. Your credentials are stored securely and we only access emails with your permission.",
    "connectGmail": "Connect Gmail",
    "connectOutlook": "Connect Outlook",
    "connectImap": "Connect IMAP (Any Email)",
    "connectedAccounts": "Connected Accounts",
    "noConnections": "No email accounts connected yet. Connect Gmail, Outlook, or any email via IMAP to get started.",
    "lastSync": "Last sync",
    "neverSynced": "Never",
    "syncNow": "Sync now",
    "disconnect": "Disconnect",
    "imapForm": {
      "title": "Connect via IMAP",
      "description": "Works with any email provider (Gmail, Outlook, Yahoo, etc.). For Gmail/Outlook, use an App Password instead of your regular password.",
      "emailLabel": "Email Address",
      "emailPlaceholder": "your.email@example.com",
      "passwordLabel": "Password / App Password",
      "passwordPlaceholder": "••••••••",
      "gmailAppPasswordHelp": "For Gmail: Create App Password",
      "advancedSettings": "Advanced Settings (Optional - auto-detected for common providers)",
      "imapServerLabel": "IMAP Server",
      "imapServerPlaceholder": "imap.gmail.com",
      "portLabel": "Port",
      "portPlaceholder": "993",
      "useTls": "Use TLS/SSL (Recommended)",
      "connecting": "Connecting...",
      "connect": "Connect",
      "cancel": "Cancel"
    },
    "messages": {
      "connectionSuccess": "{provider} connected successfully: {email}",
      "connectionError": "Connection error: {error}",
      "gmailConnectError": "Failed to connect Gmail. Please try again.",
      "outlookConnectError": "Failed to connect Outlook. Please try again.",
      "imapConnectError": "Failed to connect via IMAP. Please check your credentials.",
      "disconnectConfirm": "Are you sure you want to disconnect this {provider} account? All synced emails will be removed.",
      "disconnectSuccess": "Email account disconnected successfully",
      "disconnectError": "Failed to disconnect email account",
      "syncStarted": "Email sync started. This may take a few moments.",
      "syncError": "Failed to start email sync",
      "loadError": "Failed to load email connections"
    },
    "errors": {
      "microsoftOAuthRequired": "Microsoft has disabled password authentication for your organization. Please use the 'Connect Outlook' button instead to authenticate via OAuth, or contact your IT administrator for access.",
      "gmailAppPasswordRequired": "Gmail requires an App Password. Please create one in your Google Account settings and try again.",
      "invalidCredentials": "Invalid email address or password. Please check your credentials and try again.",
      "connectionTimeout": "Connection timed out. Please check your internet connection and try again.",
      "serverNotFound": "Email server not found. Please verify your IMAP settings in Advanced Settings."
    },
    "info": {
      "title": "How it works",
      "point1": "Emails are synced automatically every 15 minutes",
      "point2": "You can manually sync anytime by clicking the refresh button",
      "point3": "Disconnect anytime to stop syncing. Your emails in MortgageFlow will be removed."
    }
  },
  "legal": {
    "backToHome": "Back to Home",
    "privacy": {
      "title": "Privacy Policy",
      "lastUpdated": "Last Updated",
      "updateDate": "October 12, 2024",
      "introduction": {
        "title": "Introduction",
        "p1": "MortgageFlow.pro (\"we\", \"us\", or \"our\") is committed to protecting your privacy and the confidentiality of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mortgage brokering platform and services.",
        "p2": "As a platform serving mortgage brokers and their clients, we understand the sensitive nature of financial information and are committed to maintaining the highest standards of data protection and privacy."
      },
      "collection": {
        "title": "Information We Collect",
        "personal": {
          "title": "Personal Information from Brokers",
          "item1": "Account information (name, email address, phone number, business details)",
          "item2": "Professional credentials and licensing information",
          "item3": "Payment and billing information",
          "item4": "Communication preferences and settings"
        },
        "client": {
          "title": "Client Information Entered by Brokers",
          "item1": "Client contact information (names, addresses, phone numbers, emails)",
          "item2": "Financial information related to mortgage applications",
          "item3": "Property information and transaction details",
          "item4": "Documents and files uploaded to the platform"
        },
        "usage": {
          "title": "Usage and Technical Data",
          "item1": "Log data, IP addresses, browser type, and device information",
          "item2": "Usage patterns, features accessed, and interaction data",
          "item3": "Cookies and similar tracking technologies"
        }
      },
      "usage": {
        "title": "How We Use Your Information",
        "item1": "Provide, maintain, and improve our mortgage brokering platform",
        "item2": "Process transactions and manage subscriptions",
        "item3": "Send administrative information, updates, and security alerts",
        "item4": "Respond to inquiries and provide customer support",
        "item5": "Analyze usage patterns to improve user experience",
        "item6": "Comply with legal obligations and regulatory requirements",
        "item7": "Detect, prevent, and address technical issues and security incidents"
      },
      "security": {
        "title": "Data Security",
        "p1": "We implement industry-standard security measures to protect your information, including:",
        "item1": "End-to-end encryption for data transmission (TLS/SSL)",
        "item2": "Encrypted data storage using AES-256 encryption",
        "item3": "Multi-factor authentication (2FA) and passkey support",
        "item4": "Regular security audits and vulnerability assessments",
        "item5": "Strict access controls and employee confidentiality agreements"
      },
      "sharing": {
        "title": "Information Sharing and Disclosure",
        "p1": "We do not sell your personal information. We may share information only in the following circumstances:",
        "item1": "Service Providers: With trusted third-party service providers (payment processors, cloud hosting, analytics) who assist in operating our platform",
        "item2": "Legal Compliance: When required by law, legal process, or governmental request",
        "item3": "Business Transfers: In connection with a merger, acquisition, or sale of assets",
        "item4": "With Your Consent: When you explicitly authorize us to share information"
      },
      "rights": {
        "title": "Your Privacy Rights",
        "p1": "Depending on your location, you may have the following rights:",
        "item1": "Access: Request access to your personal information",
        "item2": "Correction: Request correction of inaccurate or incomplete data",
        "item3": "Deletion: Request deletion of your personal information",
        "item4": "Portability: Request a copy of your data in a structured format",
        "item5": "Objection: Object to certain processing of your information",
        "item6": "Withdrawal: Withdraw consent where processing is based on consent"
      },
      "cookies": {
        "title": "Cookies and Tracking Technologies",
        "p1": "We use cookies and similar technologies to enhance your experience, analyze usage, and remember your preferences. You can control cookies through your browser settings.",
        "p2": "Essential cookies are required for platform functionality, while analytics and preference cookies can be disabled without affecting core features."
      },
      "retention": {
        "title": "Data Retention",
        "p1": "We retain your information for as long as necessary to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements. When data is no longer needed, we securely delete or anonymize it."
      },
      "changes": {
        "title": "Changes to This Privacy Policy",
        "p1": "We may update this Privacy Policy periodically. We will notify you of significant changes via email or through a prominent notice on our platform. Your continued use of the service after changes constitutes acceptance of the updated policy."
      },
      "contact": {
        "title": "Contact Us",
        "p1": "If you have questions about this Privacy Policy or wish to exercise your privacy rights, please contact us:",
        "email": "Email",
        "address": "Address",
        "addressValue": "Canada"
      }
    },
    "terms": {
      "title": "Terms of Service",
      "lastUpdated": "Last Updated",
      "updateDate": "February 1, 2026",
      "introduction": {
        "title": "Introduction",
        "p1": "Welcome to MortgageFlow.pro. These Terms of Service (\"Terms\") govern your access to and use of our mortgage brokering platform, services, and software (collectively, the \"Service\").",
        "p2": "MortgageFlow.pro provides a comprehensive software platform designed specifically for mortgage brokers to manage their business operations, client relationships, deal pipelines, and administrative tasks."
      },
      "acceptance": {
        "title": "Acceptance of Terms",
        "p1": "By creating an account, accessing, or using our Service, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access or use our Service. If you are using the Service on behalf of an organization, you represent that you have authority to bind that organization to these Terms."
      },
      "service": {
        "title": "Service Description",
        "p1": "MortgageFlow.pro provides a cloud-based platform that includes:",
        "item1": "Customer Relationship Management (CRM) for mortgage clients",
        "item2": "Lead management and tracking",
        "item3": "Deal pipeline management with customizable stages",
        "item4": "Task management and workflow automation",
        "item5": "Communication tools (SMS, email, calling)",
        "item6": "Calendar and appointment scheduling",
        "item7": "Team collaboration and user management",
        "item8": "Custom forms and intake processes",
        "item9": "Document management and storage",
        "item10": "AI-powered conversation summaries and insights",
        "item11": "Reporting, analytics, and commission calculations",
        "item12": "Integration capabilities (Calendly and other tools)"
      },
      "accounts": {
        "title": "User Accounts and Registration",
        "p1": "To use our Service, you must create an account and provide accurate, complete information. You agree to:",
        "item1": "Maintain the security and confidentiality of your account credentials",
        "item2": "Notify us immediately of any unauthorized access or security breach",
        "item3": "Be responsible for all activities that occur under your account",
        "item4": "Provide accurate professional credentials and licensing information if required"
      },
      "payment": {
        "title": "Subscription and Payment",
        "freeTrial": {
          "title": "Free Trial",
          "p1": "New users receive a 30-day free trial of our Pro plan with full access to all features. No credit card is required to start your trial. At the end of the trial period, you must select and pay for a subscription plan to continue using the Service."
        },
        "pricing": {
          "title": "Pricing and Plans",
          "p1": "MortgageFlow.pro offers four subscription tiers: Lite, Growth, Pro, and Enterprise. Each plan has different features, limitations, and pricing. Current pricing is available on our website and may be updated periodically with 30 days' advance notice to existing subscribers.",
          "p2": "Plan limitations (such as maximum number of active deals and leads) are enforced automatically. Upgrading to a higher tier will immediately unlock additional capacity."
        },
        "billing": {
          "title": "Billing Terms",
          "item1": "Subscriptions are billed in advance on a monthly or annual basis",
          "item2": "Annual subscriptions receive discounted pricing (up to 50% savings)",
          "item3": "All fees are non-refundable except as required by law or during the trial period",
          "item4": "We may change pricing with 30 days' advance notice to existing subscribers",
          "item5": "Failed payments may result in service suspension until payment is received"
        },
        "cancellation": {
          "title": "Cancellation and Refunds",
          "p1": "You may cancel your subscription at any time through your account settings. Cancellation will take effect at the end of your current billing period. You will retain access to paid features until that date. No refunds will be provided for partial billing periods, except where required by law."
        }
      },
      "obligations": {
        "title": "User Obligations and Acceptable Use",
        "p1": "You agree to use our Service only for lawful purposes and in accordance with these Terms. You specifically agree NOT to:",
        "item1": "Violate any applicable laws, regulations, or third-party rights",
        "item2": "Use the Service for any fraudulent or malicious purposes",
        "item3": "Attempt to gain unauthorized access to our systems or networks",
        "item4": "Interfere with or disrupt the Service or servers",
        "item5": "Upload or transmit viruses, malware, or malicious code",
        "item6": "Scrape, copy, or extract data from the Service without authorization"
      },
      "intellectual": {
        "title": "Intellectual Property Rights",
        "p1": "The Service, including all software, designs, text, graphics, and other content, is owned by MortgageFlow.pro and protected by copyright, trademark, and other intellectual property laws.",
        "p2": "You retain ownership of all client data and content you upload to the Service. By using the Service, you grant us a limited license to store, process, and display your content solely to provide the Service to you."
      },
      "data": {
        "title": "Data and Privacy",
        "p1": "Your use of the Service is governed by our Privacy Policy, which is incorporated into these Terms by reference. You are responsible for ensuring you have proper authorization to collect, use, and share client information through our platform.",
        "p2": "You represent and warrant that your use of the Service complies with all applicable privacy laws and regulations, including obtaining necessary consents from your clients."
      },
      "prohibited": {
        "title": "Prohibited Activities",
        "item1": "Reselling or redistributing the Service without authorization",
        "item2": "Reverse engineering, decompiling, or attempting to extract source code",
        "item3": "Using the Service to send spam or unsolicited communications",
        "item4": "Impersonating another person or entity",
        "item5": "Collecting information about other users without consent",
        "item6": "Creating multiple accounts to evade restrictions",
        "item7": "Violating mortgage industry regulations or professional standards"
      },
      "availability": {
        "title": "Service Availability and Modifications",
        "p1": "We strive to provide reliable, continuous service but do not guarantee uninterrupted access. We may modify, suspend, or discontinue any part of the Service at any time with reasonable notice. We will not be liable for any modifications, suspensions, or discontinuations.",
        "p2": "Scheduled maintenance will be announced in advance whenever possible. We aim for 99.5% uptime but do not provide formal SLA guarantees except for Enterprise customers with separate agreements."
      },
      "apiAccess": {
        "title": "API Access and Integration",
        "p1": "API access is available exclusively to Enterprise plan subscribers. Use of our API is subject to rate limits and fair use policies.",
        "p2": "You may not use the API to circumvent subscription limits, extract data for competing services, or overload our systems. We reserve the right to revoke API access for abuse or violation of these Terms."
      },
      "liability": {
        "title": "Limitation of Liability",
        "p1": "TO THE MAXIMUM EXTENT PERMITTED BY LAW, MORTGAGEFLOW.PRO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, OR OTHER INTANGIBLE LOSSES.",
        "p2": "Our total liability to you for any claims arising from these Terms or your use of the Service shall not exceed the amount you paid us in the 12 months preceding the claim."
      },
      "warranty": {
        "title": "Warranty Disclaimer",
        "p1": "THE SERVICE IS PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.",
        "p2": "We do not warrant that the Service will be uninterrupted, error-free, or secure, or that defects will be corrected. We do not warrant the accuracy, completeness, or reliability of any content or data provided through the Service.",
        "p3": "You acknowledge that you use the Service at your own risk and that we are not responsible for any business decisions made based on information or tools provided by the Service."
      },
      "indemnification": {
        "title": "Indemnification",
        "p1": "You agree to indemnify, defend, and hold harmless MortgageFlow.pro, its officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses arising from your use of the Service, violation of these Terms, or infringement of any third-party rights."
      },
      "termination": {
        "title": "Termination",
        "p1": "We may suspend or terminate your account and access to the Service at any time, with or without cause, with or without notice, for any violation of these Terms or for any other reason.",
        "p2": "Upon termination, you will lose access to your account and data. You may request an export of your data within 30 days of termination, after which we may permanently delete your data."
      },
      "dataRetention": {
        "title": "Data Retention and Export",
        "p1": "We retain your data for the duration of your subscription. Upon cancellation or termination, your data will remain accessible for 30 days to allow you to export it.",
        "p2": "You can export your data at any time through your account settings or by contacting support. After the 30-day grace period, we will permanently and irreversibly delete all your data from our systems in accordance with our data retention policies and applicable laws.",
        "p3": "We are not responsible for any data loss resulting from your failure to export data before permanent deletion."
      },
      "governing": {
        "title": "Governing Law and Dispute Resolution",
        "p1": "These Terms are governed by the laws of Canada. Any disputes arising from these Terms or the Service will be resolved through binding arbitration in accordance with applicable arbitration rules, except where prohibited by law."
      },
      "modifications": {
        "title": "Changes to Terms",
        "p1": "We reserve the right to modify these Terms at any time. We will notify you of material changes via email or through the Service. Your continued use of the Service after such notification constitutes acceptance of the modified Terms."
      },
      "contact": {
        "title": "Contact Information",
        "p1": "If you have any questions about these Terms of Service, please contact us:",
        "email": "Email",
        "address": "Address",
        "addressValue": "Canada"
      }
    }
  },
  "mortgageCalculator": {
    "title": "Mortgage Calculator & Comparator",
    "description": "Compare multiple mortgage scenarios to find the best option for your needs",
    "saveScenarios": "Save Scenarios",
    "viewHistory": "View History",
    "hideHistory": "Hide History",
    "exportPDF": "Export PDF",
    "saving": "Saving...",
    "saved": "Saved!",
    "saveFailed": "Save Failed",
    "generating": "Generating...",
    "customerName": "Customer Name",
    "customerNamePlaceholder": "Enter customer name for PDF",
    "propertyAddress": "Property Address",
    "propertyAddressPlaceholder": "Enter property address for PDF",
    "activeScenarios": "Active Scenarios",
    "scenario": "Scenario {{number}}",
    "bankLender": "Bank / Lender",
    "bankPlaceholder": "e.g., TD Bank, RBC, Scotia, etc.",
    "commentsNotes": "Comments / Notes",
    "commentsPlaceholder": "Special conditions, notes, or additional details...",
    "coreFinancialCalculator": "Core Financial Calculator",
    "calculate": "Calculate",
    "calculatorInstructions": "Enter any 3 values, leave 1 empty, and click Calculate to find the missing value.",
    "mortgageAmount": "Mortgage Amount",
    "mortgageAmountPrincipal": "Mortgage Amount (Principal)",
    "interestRate": "Interest Rate (% per year)",
    "amortizationPeriod": "Amortization Period",
    "amortizationPeriodFull": "Amortization Period (Total payoff time)",
    "paymentAmount": "Payment Amount",
    "months": "Months",
    "monthsAbbr": "Mor",
    "years": "Years",
    "monthly": "Monthly",
    "loadingCalculator": "Loading calculator...",
    "best": "Best",
    "highest": "Highest",
    "savedScenariosHistory": "Saved Scenarios History",
    "browseSaved": "Browse and download previously saved mortgage comparisons",
    "selectCustomer": "Select Customer",
    "searchCustomers": "Search customers...",
    "loadingCustomers": "Loading customers...",
    "noCustomersFound": "No customers found",
    "selectACustomer": "Select a Customer",
    "selectCustomerDesc": "Choose a customer from the list to view their saved mortgage scenarios",
    "customerScenarios": "{{name}}'s Scenarios",
    "savedScenarioCount": "{{count}} saved scenario",
    "savedScenarioCount_plural": "{{count}} saved scenarios",
    "noSavedScenarios": "No Saved Scenarios",
    "noSavedScenariosDesc": "This customer doesn't have any saved mortgage scenarios yet",
    "deleteConfirm": "Are you sure you want to delete this saved scenario?",
    "download": "Download",
    "generating": "Generating...",
    "customer": "Customer",
    "property": "Property",
    "deleteScenario": "Delete scenario",
    "scenarioComparison": "Scenario Comparison",
    "propertyValue": "Property Value",
    "scenario1": "Scenario 1",
    "scenario2": "Scenario 2",
    "scenario3": "Scenario 3"
  },
  "sms": {
    "conversations": "Conversations",
    "noPhone": "No phone",
    "applicant": "Applicant",
    "coApplicant": "Co-Applicant",
    "readOnlyMode": "Read-only Mode",
    "noMessages": "No messages yet. Start a conversation!",
    "today": "Today",
    "yesterday": "Yesterday",
    "typeMessage": "Type a message...",
    "sendingFrom": "Sending from",
    "customerNoPhone": "Customer has no phone number",
    "noPhoneNumberAssigned": "You need an assigned phone number to send SMS. Contact your administrator.",
    "errorFetchingMessages": "Error fetching messages",
    "noPhoneNumber": "Customer has no phone number",
    "errorSendingMessage": "Error sending message",
    "noCustomers": "No Customers",
    "noCustomersDescription": "This deal has no customers associated. Add customers to start SMS conversations."
  },
  "conversations": {
    "title": "Messages",
    "newChat": "New Chat",
    "searchPlaceholder": "Search conversations...",
    "noConversationsFound": "No conversations found",
    "noConversationsYet": "No SMS conversations yet",
    "relatedPerson": "Related Person",
    "unknown": "Unknown",
    "selectConversation": "Select a conversation",
    "selectConversationDescription": "Choose a conversation from the sidebar to start messaging",
    "startNewConversation": "Start New Conversation",
    "searchContactsPlaceholder": "Search customers and contacts...",
    "orEnterPhoneNumber": "Or enter a phone number",
    "phoneNumberPlaceholder": "e.g., +1 514 123 4567",
    "startConversation": "Start Conversation",
    "invalidPhoneNumber": "Please enter a valid phone number",
    "searching": "Searching...",
    "noContactsFound": "No contacts found",
    "typeToSearch": "Type to search for customers and contacts",
    "contact": "Contact",
    "deleteConversation": "Delete Conversation",
    "deleteConversationConfirm": "Are you sure you want to delete this conversation with",
    "deleteConversationWarning": "This action cannot be undone. All messages in this conversation will be permanently deleted.",
    "loadingConversations": "Loading conversations...",
    "realTime": "Real-time",
    "reconnecting": "Reconnecting...",
    "typeMessage": "Type a message...",
    "phoneNumberRequired": "Phone Number Required",
    "phoneNumberRequiredDescription": "To use SMS conversations, you need to set up a dedicated phone number. This allows you to send and receive messages with your clients.",
    "setupPhoneNumber": "Set Up Phone Number",
    "phoneNumberHint": "Once configured, you'll be able to send and receive SMS messages from this page."
  },
  "calls": {
    "comingSoon": "Coming Soon",
    "comingSoonDescription": "The call recordings feature is currently in development and will be available soon. Stay tuned!",
    "comingSoonHint": "This feature will allow you to view, manage, and analyze your call recordings with AI-powered transcription and insights."
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Generate comprehensive reports and analytics for your business",
    "selectCategory": "Select Report Category",
    "availableReports": "Available Reports",
    "noReports": "No reports available in this category",
    "dateRange": "Date Range",
    "filterable": "Filterable",
    "startDate": "Start Date",
    "endDate": "End Date",
    "refresh": "Refresh",
    "filters": "Filters",
    "applyFilters": "Apply Filters",
    "exportCSV": "Export CSV",
    "exportPDF": "Export PDF",
    "noData": "No data available for the selected criteria",
    "categories": {
      "all": "All Reports",
      "allDescription": "View all available reports",
      "sales": "Sales & Revenue",
      "salesDescription": "Financial performance and commission reports",
      "customers": "Customers & Leads",
      "customersDescription": "Customer acquisition and conversion reports",
      "deals": "Deals & Pipeline",
      "dealsDescription": "Deal tracking and pipeline analysis",
      "activities": "Tasks & Activities",
      "activitiesDescription": "Task completion and activity tracking",
      "communications": "Communications",
      "communicationsDescription": "Call logs and message analytics",
      "performance": "Performance",
      "performanceDescription": "Team performance and trends"
    },
    "revenueSummary": {
      "name": "Revenue Summary",
      "description": "Total revenue breakdown by period"
    },
    "commissionReport": {
      "name": "Commission Report",
      "description": "Detailed commission earnings by deal"
    },
    "dealPipelineValue": {
      "name": "Pipeline Value",
      "description": "Current value of deals in pipeline"
    },
    "customerList": {
      "name": "Customer List",
      "description": "Complete list of all customers"
    },
    "customerAcquisition": {
      "name": "Customer Acquisition",
      "description": "New customer growth over time"
    },
    "leadConversion": {
      "name": "Lead Conversion",
      "description": "Lead to customer conversion rates"
    },
    "dealsByStatus": {
      "name": "Deals by Status",
      "description": "Distribution of deals across statuses"
    },
    "dealsByType": {
      "name": "Deals by Type",
      "description": "Breakdown of deals by type"
    },
    "closedDeals": {
      "name": "Closed Deals",
      "description": "All deals closed in period"
    },
    "dealDuration": {
      "name": "Deal Duration",
      "description": "Average time to close deals"
    },
    "tasksSummary": {
      "name": "Tasks Summary",
      "description": "Overview of all tasks"
    },
    "tasksCompletion": {
      "name": "Task Completion Rate",
      "description": "Task completion statistics"
    },
    "appointments": {
      "name": "Appointments",
      "description": "Calendar appointments and meetings"
    },
    "callLog": {
      "name": "Call Log",
      "description": "Complete call history"
    },
    "messageVolume": {
      "name": "Message Volume",
      "description": "SMS and message statistics"
    },
    "communicationSummary": {
      "name": "Communication Summary",
      "description": "Overall communication activity"
    },
    "brokerPerformance": {
      "name": "Broker Performance",
      "description": "Individual broker statistics"
    },
    "conversionRates": {
      "name": "Conversion Rates",
      "description": "Lead and deal conversion metrics"
    },
    "monthlyTrends": {
      "name": "Monthly Trends",
      "description": "Month-over-month performance trends"
    },
    "filterLabels": {
      "status": "Status",
      "source": "Source",
      "assigned_to": "Assigned To"
    },
    "filterPlaceholders": {
      "status": "Filter by status",
      "source": "Filter by source",
      "assigned_to": "Filter by assignee"
    }
  },
  "landing": {
    "nav": {
      "signIn": "Sign In",
      "getStarted": "Get Started"
    },
    "hero": {
      "title": "Mortgage CRM built for",
      "titleHighlight": "modern brokers",
      "subtitle": "Complete client management workflow, deal tracking, and AI automation tools specifically designed for your team.",
      "description": "Enhance your in house communication on a trusted secure plateform.",
      "startTrial": "Start Free Trial",
      "viewDemo": "View Demo"
    },
    "highlights": {
      "setupTime": {
        "label": "Setup Time",
        "value": "5 Minutes",
        "description": "Quick onboarding process"
      },
      "freeTrial": {
        "label": "Free Trial",
        "value": "30 Days",
        "description": "No credit card required"
      },
      "support": {
        "label": "Support",
        "value": "24/7",
        "description": "Always here to help"
      }
    },
    "features": {
      "title": "Everything you need in one platform",
      "subtitle": "Streamline your workflow with tools built specifically for mortgage professionals.",
      "clientManagement": {
        "title": "Client Management",
        "description": "Comprehensive profiles, contact history, document storage, and automated follow-ups all in one place.",
        "features": {
          "profiles": "Detailed client profiles",
          "followups": "Automated follow-ups",
          "documents": "Document management"
        }
      },
      "dealPipeline": {
        "title": "Deal Pipeline",
        "description": "Visual deal tracking with customizable stages, commission tracking, and real-time progress updates.",
        "features": {
          "kanban": "Kanban-style boards",
          "commission": "Commission calculator",
          "progress": "Progress tracking"
        }
      },
      "aiAutomation": {
        "title": "AI Automation",
        "description": "Automatic conversation summaries, intelligent task management, and smart scheduling assistance.",
        "features": {
          "summaries": "AI summaries",
          "scheduling": "Smart scheduling",
          "tasks": "Task automation"
        }
      },
      "calendar": {
        "title": "Calendar & Appointments",
        "description": "Schedule meetings and manage appointments"
      },
      "teamCollaboration": {
        "title": "Team Collaboration",
        "description": "Invite team members and work together"
      },
      "leadManagement": {
        "title": "Lead Management",
        "description": "Capture, track, and convert leads"
      },
      "emailIntegration": {
        "title": "Email Integration",
        "description": "Send and track emails directly from the CRM"
      },
      "workflows": {
        "title": "Workflows & Automation",
        "description": "Automate repetitive tasks and processes"
      },
      "customForms": {
        "title": "Custom Forms",
        "description": "Create custom intake and application forms"
      },
      "reports": {
        "title": "Reports & Analytics",
        "description": "Generate comprehensive business reports"
      },
      "analytics": {
        "title": "Analytics",
        "description": "Performance metrics and insights"
      },
      "customDashboard": {
        "title": "Custom Dashboard",
        "description": "Personalize your workspace with custom widgets"
      },
      "communications": {
        "title": "Communications",
        "description": "Integrated calls, SMS, and messaging"
      },
      "security": {
        "title": "Security",
        "description": "Enterprise-grade data protection"
      },
      "mobile": {
        "title": "Mobile Ready",
        "description": "Access from any device, anywhere"
      }
    },
    "pricing": {
      "title": "Simple, transparent pricing",
      "subtitle": "Start with a 30-day free trial of our Pro version — no credit card required",
      "monthly": "Monthly",
      "annually": "Annually",
      "annuallySave": "Save up to 50%",
      "perMonth": "/month",
      "billed": "billed",
      "freeTrial": "30-day Pro trial included",
      "lite": {
        "name": "Lite",
        "monthlyPrice": "19",
        "annualPrice": "9",
        "description": "Perfect for individual brokers starting out",
        "features": [
          "Up to 10 active deals",
          "Up to 20 active leads",
          "Basic CRM features",
          "Email & SMS integration",
          "Mobile app access",
          "Enterprise-grade security",
          "Email support"
        ],
        "cta": "Start Free Trial"
      },
      "growth": {
        "name": "Growth",
        "monthlyPrice": "39",
        "annualPrice": "29",
        "description": "For growing teams and brokerages",
        "features": [
          "Everything in Lite",
          "Unlimited deals & leads",
          "Advanced CRM & automation",
          "Team collaboration",
          "Custom workflows",
          "Enterprise-grade security",
          "Priority support"
        ],
        "cta": "Start Free Trial",
        "popular": "Most Popular"
      },
      "pro": {
        "name": "Pro",
        "monthlyPrice": "69",
        "annualPrice": "49",
        "description": "Advanced features for established brokerages",
        "features": [
          "Everything in Growth",
          "Calendar & Appointments",
          "Calendly integration",
          "Custom forms",
          "AI Workflows management",
          "Advanced analytics & reports",
          "White-label options",
          "Enterprise-grade security",
          "Dedicated account manager"
        ],
        "cta": "Start Free Trial"
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Custom",
        "description": "Tailored solutions for large organizations",
        "features": [
          "Everything in Pro",
          "Custom development",
          "SLA guarantees",
          "Enterprise-grade security",
          "Personalized onboarding",
          "API access",
          "24/7 priority phone support"
        ],
        "cta": "Contact Us"
      }
    },
    "cta": {
      "title": "Start managing your deals more effectively",
      "subtitle": "Join mortgage professionals using MortgageFlow to streamline their workflow. Try it free for 30 days.",
      "getStarted": "Get Started Free",
      "signIn": "Sign In",
      "footer": "No credit card required • 30-day free trial • Cancel anytime"
    },
    "footer": {
      "privacy": "Privacy",
      "terms": "Terms",
      "support": "Support",
      "contact": "Contact",
      "copyright": "© 2026 MortgageFlow. All rights reserved."
    },
    "mockup": {
      "widget1": "Active Deals",
      "widget2": "Recent Activity",
      "widget3": "Commission Tracking",
      "widget4": "Tasks Overview"
    }
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Generate and download comprehensive business reports",
    "selectCategory": "Select Report Category",
    "availableReports": "Available Reports",
    "noReports": "No reports available in this category",
    "noData": "No data available for this report",
    "dateRange": "Date Range",
    "filterable": "Filterable",
    "startDate": "Start Date",
    "endDate": "End Date",
    "refresh": "Refresh Report",
    "filters": "Filters",
    "applyFilters": "Apply Filters",
    "exportCSV": "Export CSV",
    "exportPDF": "Export PDF",
    "categories": {
      "all": "All Reports",
      "allDescription": "View all available reports",
      "sales": "Sales Reports",
      "salesDescription": "Revenue, commissions, and pipeline value",
      "customers": "Customer Reports",
      "customersDescription": "Customer lists, acquisition, and conversion",
      "deals": "Deal Reports",
      "dealsDescription": "Deal status, types, and performance",
      "activities": "Activity Reports",
      "activitiesDescription": "Tasks, appointments, and completion tracking",
      "communications": "Communication Reports",
      "communicationsDescription": "Call logs, messages, and communication summary",
      "performance": "Performance Reports",
      "performanceDescription": "Broker performance, conversion rates, and trends"
    },
    "revenueSummary": {
      "name": "Revenue Summary",
      "description": "Overview of revenue and commissions from closed deals"
    },
    "commissionReport": {
      "name": "Commission Report",
      "description": "Detailed breakdown of commissions earned"
    },
    "dealPipelineValue": {
      "name": "Deal Pipeline Value",
      "description": "Current value of all active deals in pipeline"
    },
    "customerList": {
      "name": "Customer List",
      "description": "Complete list of customers with filters"
    },
    "customerAcquisition": {
      "name": "Customer Acquisition",
      "description": "New customer acquisition by date and source"
    },
    "leadConversion": {
      "name": "Lead Conversion",
      "description": "Lead to customer conversion metrics"
    },
    "dealsByStatus": {
      "name": "Deals by Status",
      "description": "Breakdown of deals by current status"
    },
    "dealsByType": {
      "name": "Deals by Type",
      "description": "Analysis of deals by mortgage type"
    },
    "closedDeals": {
      "name": "Closed Deals",
      "description": "All successfully closed deals"
    },
    "dealDuration": {
      "name": "Deal Duration",
      "description": "Time taken from deal creation to close"
    },
    "tasksSummary": {
      "name": "Tasks Summary",
      "description": "Overview of tasks by status"
    },
    "tasksCompletion": {
      "name": "Tasks Completion",
      "description": "Completed tasks with timing analysis"
    },
    "appointments": {
      "name": "Appointments",
      "description": "List of all appointments"
    },
    "callLog": {
      "name": "Call Log",
      "description": "Complete log of all phone calls"
    },
    "messageVolume": {
      "name": "Message Volume",
      "description": "SMS message volume by date and direction"
    },
    "communicationSummary": {
      "name": "Communication Summary",
      "description": "Combined calls and messages summary"
    },
    "brokerPerformance": {
      "name": "Broker Performance",
      "description": "Overall performance metrics for broker"
    },
    "conversionRates": {
      "name": "Conversion Rates",
      "description": "Deal conversion and win rate analysis"
    },
    "monthlyTrends": {
      "name": "Monthly Trends",
      "description": "Monthly performance trends and patterns"
    },
    "filterLabels": {
      "status": "Status",
      "source": "Source",
      "assigned_to": "Assigned To"
    },
    "filterPlaceholders": {
      "status": "Filter by status...",
      "source": "Filter by source...",
      "assigned_to": "Filter by user..."
    },
    "selectReportPrompt": "Select a Report",
    "selectReportDescription": "Choose a report from the categories above to view data",
    "generateReport": "Generate Report",
    "generating": "Generating Report..."
  },
  "impersonating": "You are impersonating a user. Be careful with changes.",
  "switchBack": "Switch Back to My Account",
  "dealValidation": {
    "title": "Complete Required Fields",
    "subtitle": "Fill in the missing information to move this deal to",
    "required": "required",
    "saveAndMove": "Save & Move",
    "saving": "Saving…",
    "cancel": "Cancel",
    "noMissingFields": "No missing fields detected.",
    "stillMissing": "Still missing",
    "errorOccurred": "An unexpected error occurred",
    "fields": {
      "amount": "Deal Amount",
      "customer_id": "Client",
      "lender_id": "Lender",
      "lender_name": "Lender Name",
      "deal_type_id": "Deal Type",
      "closing_date": "Closing Date",
      "description": "Notes",
      "notes": "Notes",
      "base_points": "Base Points",
      "bonus_points": "Bonus Points",
      "volume_points": "Volume Points",
      "property_address": "Property Address",
      "funded_date": "Funding Date",
      "commission_amount": "Commission Amount"
    },
    "lender": {
      "searchPlaceholder": "Search lender…",
      "createNew": "Create \"{{name}}\"",
      "selectPlaceholder": "Select a lender…",
      "creating": "Creating…",
      "noResults": "No lenders found"
    },
    "select": {
      "client": "Select a client…",
      "dealType": "Select a deal type…"
    }
  }
} 